/**
 * Generated by orval v8.1.0 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssociateCustomerSuccessMeetingDateTimeToPlatformRequest,
  AssociatePracticeTypeToPlatformRequest,
  AssociateSalesforceAccountIdToPlatformRequest,
  AssociateSalesforceIdToPlatformRequest,
  BillingEveryPlatformIntegrityViolation,
  BillingIntegrityFinding,
  CompanyBillingInfo,
  ConfirmOnboardingBrandingForPlatformRequest,
  ConfirmOnboardingBusinessVerificationForPlatformRequest,
  ConfirmOnboardingCatalogUploadForPlatformRequest,
  ConfirmOnboardingPaymentStepForPlatformRequest,
  ConfirmOnboardingUserInformationForPlatformRequest,
  CreateMembershipFromCatalogRequest,
  CreatePackageFromCatalogRequest,
  CreatePlatformRequest,
  CreateSalesAssociateRequest,
  CreateTreatmentFromCatalogRequest,
  DisplayAbbreviatedPlatformSummary,
  DisplayAllowAnonPlatformLinks,
  DisplayAllowAnonPlatformProductSubscriptions,
  DisplayBasicSmartSiteLaunchConfigurationResponse,
  DisplayBrandIconState,
  DisplayCallerIdVerificationInitiatedForPlatformLocation,
  DisplayCallerIdVerificationInitiationReference,
  DisplayCallerIdVerificationStatusForPlatformLocation,
  DisplayCompanyKybAccountsResponse,
  DisplayCompanyKybVerificationStatusForPlatform,
  DisplayCompanyVerificationInformation,
  DisplayCompanyVerificationProcess,
  DisplayCreatedPlatformResponse,
  DisplayDisputeDetails,
  DisplayDisputesForPlatform,
  DisplayExtractedPlatformBranding,
  DisplayInitiatedMembershipCatalogImportResponse,
  DisplayInitiatedPackageCatalogImportResponse,
  DisplayOperatingHoursForPlatformLocation,
  DisplayPagedPlatformSummariesResponse,
  DisplayPagedPlatformVerificationProcessesResponse,
  DisplayPlatformDomainResponse,
  DisplayPlatformOnboardingProgress,
  DisplayPlatformProductSubscriptions,
  DisplayPlgOnboardingSchedulingDetails,
  DisplayRepeatCashTransactionsForPlatform,
  DisplayRetailProductsMarketplaceVisibilitySchedule,
  DisplaySalesAssociateResponse,
  DisplaySkinDropMarketplaceVisibilitySchedule,
  DisplayVerifiedCallerIdsForPlatform,
  ExtractPlatformBrandingRequest,
  GetPagedPlatformSummariesParams,
  GetPagedPlatformVerificationProcessesParams,
  GetPlatformDomainsParams,
  GetPlatformPayoutsStatsResult,
  GetPlatformTransactionsStatsResult,
  InitiateCallerIdVerificationForPlatformLocationRequest,
  InitiatePracticeCatalogDataImportBody,
  LatestPracticeCatalogDataImportRetrievedResponse,
  PlatformLocationsTimezonesResult,
  PlatformModel,
  PlatformPricingTierModel,
  PlatformSettingsUpdatedEvent,
  PlatformSwitchedToStripeRegionEvent,
  PlatformsRetrieveBillingIntegrityFindingsParams,
  PracticeCatalogDataImportPreview,
  PracticeCatalogDataImportStatus,
  PracticeTypeAssociatedToPlatformEvent,
  ProblemDetails,
  RegenerateBrandIconsForPlatformRequest,
  RegeneratePlatformShortLinksParams,
  RequestCustomDomainForPlatformRequest,
  RetrieveBillingEveryPlatformIntegrityViolationsParams,
  SalesforceAccountIdAssociatedToPlatformEvent,
  SalesforceIdAssociatedToPlatformEvent,
  ScheduleRetailProductsVisibilityOnMarketplaceRequest,
  ScheduleSkinDropVisibilityOnMarketplaceRequest,
  SetAgelessOpportunityForPlatformRequest,
  SetCompanyKybVerificationStatusForPlatformRequest,
  SetDataPrivacyRegionForPlatformRequest,
  SetOperatingHoursForPlatformLocationRequest,
  SetRepeatMdOpportunityForPlatformRequest,
  SetSalesforceParentAccountIdForPlatformRequest,
  SubmitCancellationRequest,
  UpdatePlatformDomainRequest,
  UpdatePlatformFeeConfigurationRequest,
  UpdatePlatformLocationRequest,
  UpdatePlatformRequest,
  UpdatePlatformSettingsRequest,
  UpdatePlatformTipSettingsRequest,
  UpdateSalesAssociateRequest
} from '.././model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




/**
 * @summary Returns operational platform product subscriptions for the specified platform.
Anonymous-safe: operational product list only (no customer-history or billing signals).
 */
export const getAllowAnonProductSubscriptionsForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAllowAnonPlatformProductSubscriptions>(
      {url: `/api/v1/platforms/${platformId}/product-subscriptions`, method: 'GET', signal
    },
      );
    }
  



export const getGetAllowAnonProductSubscriptionsForPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/product-subscriptions`
    ] as const;
    }

    
export const getGetAllowAnonProductSubscriptionsForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllowAnonProductSubscriptionsForPlatformQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>> = ({ signal }) => getAllowAnonProductSubscriptionsForPlatform(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllowAnonProductSubscriptionsForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>>
export type GetAllowAnonProductSubscriptionsForPlatformQueryError = ErrorType<unknown>


/**
 * @summary Returns operational platform product subscriptions for the specified platform.
Anonymous-safe: operational product list only (no customer-history or billing signals).
 */

export function useGetAllowAnonProductSubscriptionsForPlatform<TData = Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonProductSubscriptionsForPlatform>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAllowAnonProductSubscriptionsForPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Returns shareable platform links for the specified platform.
Anonymous-safe: app, shortcut, and check-in URLs, public brand color/tint, public brand asset URLs
(logo, favicon, mobile app icons — already served anonymously by the tenant-host platform endpoints),
and the signup offer disclaimer only.
 */
export const getAllowAnonLinksForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAllowAnonPlatformLinks>(
      {url: `/api/v1/platforms/${platformId}/links`, method: 'GET', signal
    },
      );
    }
  



export const getGetAllowAnonLinksForPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/links`
    ] as const;
    }

    
export const getGetAllowAnonLinksForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError = ErrorType<ProblemDetails>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllowAnonLinksForPlatformQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>> = ({ signal }) => getAllowAnonLinksForPlatform(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllowAnonLinksForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>>
export type GetAllowAnonLinksForPlatformQueryError = ErrorType<ProblemDetails>


/**
 * @summary Returns shareable platform links for the specified platform.
Anonymous-safe: app, shortcut, and check-in URLs, public brand color/tint, public brand asset URLs
(logo, favicon, mobile app icons — already served anonymously by the tenant-host platform endpoints),
and the signup offer disclaimer only.
 */

export function useGetAllowAnonLinksForPlatform<TData = Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllowAnonLinksForPlatform>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAllowAnonLinksForPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieves live violations for whether every active CoreServices platform is being billed.
 */
export const retrieveBillingEveryPlatformIntegrityViolations = (
    params: RetrieveBillingEveryPlatformIntegrityViolationsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<BillingEveryPlatformIntegrityViolation[]>(
      {url: `/api/v1/platforms/billing-reconciliation/questions/billing-every-platform`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getRetrieveBillingEveryPlatformIntegrityViolationsQueryKey = (params?: RetrieveBillingEveryPlatformIntegrityViolationsParams,) => {
    return [
    `/api/v1/platforms/billing-reconciliation/questions/billing-every-platform`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getRetrieveBillingEveryPlatformIntegrityViolationsQueryOptions = <TData = Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError = ErrorType<ProblemDetails>>(params: RetrieveBillingEveryPlatformIntegrityViolationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveBillingEveryPlatformIntegrityViolationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>> = ({ signal }) => retrieveBillingEveryPlatformIntegrityViolations(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrieveBillingEveryPlatformIntegrityViolationsQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>>
export type RetrieveBillingEveryPlatformIntegrityViolationsQueryError = ErrorType<ProblemDetails>


/**
 * @summary Retrieves live violations for whether every active CoreServices platform is being billed.
 */

export function useRetrieveBillingEveryPlatformIntegrityViolations<TData = Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError = ErrorType<ProblemDetails>>(
 params: RetrieveBillingEveryPlatformIntegrityViolationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveBillingEveryPlatformIntegrityViolations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrieveBillingEveryPlatformIntegrityViolationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieves billing integrity findings for the selected UTC reconciliation date.
 */
export const platformsRetrieveBillingIntegrityFindings = (
    params: PlatformsRetrieveBillingIntegrityFindingsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<BillingIntegrityFinding[]>(
      {url: `/api/v1/platforms/billing-reconciliation/findings`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getPlatformsRetrieveBillingIntegrityFindingsQueryKey = (params?: PlatformsRetrieveBillingIntegrityFindingsParams,) => {
    return [
    `/api/v1/platforms/billing-reconciliation/findings`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getPlatformsRetrieveBillingIntegrityFindingsQueryOptions = <TData = Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError = ErrorType<unknown>>(params: PlatformsRetrieveBillingIntegrityFindingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformsRetrieveBillingIntegrityFindingsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>> = ({ signal }) => platformsRetrieveBillingIntegrityFindings(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformsRetrieveBillingIntegrityFindingsQueryResult = NonNullable<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>>
export type PlatformsRetrieveBillingIntegrityFindingsQueryError = ErrorType<unknown>


/**
 * @summary Retrieves billing integrity findings for the selected UTC reconciliation date.
 */

export function usePlatformsRetrieveBillingIntegrityFindings<TData = Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError = ErrorType<unknown>>(
 params: PlatformsRetrieveBillingIntegrityFindingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformsRetrieveBillingIntegrityFindings>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformsRetrieveBillingIntegrityFindingsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Creates a new Platform.
 */
export const createPlatform = (
    createPlatformRequest: CreatePlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayCreatedPlatformResponse>(
      {url: `/api/v1/platforms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPlatformRequest, signal
    },
      );
    }
  


export const getCreatePlatformMutationOptions = <TError = ErrorType<void | ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlatform>>, TError,{data: CreatePlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPlatform>>, TError,{data: CreatePlatformRequest}, TContext> => {

const mutationKey = ['createPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPlatform>>, {data: CreatePlatformRequest}> = (props) => {
          const {data} = props ?? {};

          return  createPlatform(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePlatformMutationResult = NonNullable<Awaited<ReturnType<typeof createPlatform>>>
    export type CreatePlatformMutationBody = CreatePlatformRequest
    export type CreatePlatformMutationError = ErrorType<void | ProblemDetails>

    /**
 * @summary Creates a new Platform.
 */
export const useCreatePlatform = <TError = ErrorType<void | ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlatform>>, TError,{data: CreatePlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPlatform>>,
        TError,
        {data: CreatePlatformRequest},
        TContext
      > => {
      return useMutation(getCreatePlatformMutationOptions(options));
    }
    /**
 * @summary Gets a list of existing Platforms.
 */
export const platformsGetPlatforms = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformModel[]>(
      {url: `/api/v1/platforms`, method: 'GET', signal
    },
      );
    }
  



export const getPlatformsGetPlatformsQueryKey = () => {
    return [
    `/api/v1/platforms`
    ] as const;
    }

    
export const getPlatformsGetPlatformsQueryOptions = <TData = Awaited<ReturnType<typeof platformsGetPlatforms>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformsGetPlatformsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformsGetPlatforms>>> = ({ signal }) => platformsGetPlatforms(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformsGetPlatformsQueryResult = NonNullable<Awaited<ReturnType<typeof platformsGetPlatforms>>>
export type PlatformsGetPlatformsQueryError = ErrorType<unknown>


/**
 * @summary Gets a list of existing Platforms.
 */

export function usePlatformsGetPlatforms<TData = Awaited<ReturnType<typeof platformsGetPlatforms>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatforms>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformsGetPlatformsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Gets a lightweight list of platform dropdown options for the platform selector.
 */
export const getPlatformsDropdownOptions = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayAbbreviatedPlatformSummary[]>(
      {url: `/api/v1/platforms/dropdown-options`, method: 'GET', signal
    },
      );
    }
  



export const getGetPlatformsDropdownOptionsQueryKey = () => {
    return [
    `/api/v1/platforms/dropdown-options`
    ] as const;
    }

    
export const getGetPlatformsDropdownOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformsDropdownOptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>> = ({ signal }) => getPlatformsDropdownOptions(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformsDropdownOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>>
export type GetPlatformsDropdownOptionsQueryError = ErrorType<void>


/**
 * @summary Gets a lightweight list of platform dropdown options for the platform selector.
 */

export function useGetPlatformsDropdownOptions<TData = Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformsDropdownOptions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformsDropdownOptionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Gets a paginated list of platform summaries with optional search filtering.
 */
export const getPagedPlatformSummaries = (
    params?: GetPagedPlatformSummariesParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayPagedPlatformSummariesResponse>(
      {url: `/api/v1/platforms/summaries/paged`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetPagedPlatformSummariesQueryKey = (params?: GetPagedPlatformSummariesParams,) => {
    return [
    `/api/v1/platforms/summaries/paged`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetPagedPlatformSummariesQueryOptions = <TData = Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError = ErrorType<void>>(params?: GetPagedPlatformSummariesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPagedPlatformSummariesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPagedPlatformSummaries>>> = ({ signal }) => getPagedPlatformSummaries(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPagedPlatformSummariesQueryResult = NonNullable<Awaited<ReturnType<typeof getPagedPlatformSummaries>>>
export type GetPagedPlatformSummariesQueryError = ErrorType<void>


/**
 * @summary Gets a paginated list of platform summaries with optional search filtering.
 */

export function useGetPagedPlatformSummaries<TData = Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError = ErrorType<void>>(
 params?: GetPagedPlatformSummariesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformSummaries>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPagedPlatformSummariesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Gets a single Platform by id.
 */
export const platformsGetPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}`, method: 'GET', signal
    },
      );
    }
  



export const getPlatformsGetPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}`
    ] as const;
    }

    
export const getPlatformsGetPlatformQueryOptions = <TData = Awaited<ReturnType<typeof platformsGetPlatform>>, TError = ErrorType<void>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformsGetPlatformQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformsGetPlatform>>> = ({ signal }) => platformsGetPlatform(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformsGetPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof platformsGetPlatform>>>
export type PlatformsGetPlatformQueryError = ErrorType<void>


/**
 * @summary Gets a single Platform by id.
 */

export function usePlatformsGetPlatform<TData = Awaited<ReturnType<typeof platformsGetPlatform>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatform>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformsGetPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Updates a Platform identified by Platform id.
 */
export const updatePlatform = (
    platformId: string,
    updatePlatformRequest: UpdatePlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformRequest, signal
    },
      );
    }
  


export const getUpdatePlatformMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatform>>, TError,{platformId: string;data: UpdatePlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlatform>>, TError,{platformId: string;data: UpdatePlatformRequest}, TContext> => {

const mutationKey = ['updatePlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlatform>>, {platformId: string;data: UpdatePlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  updatePlatform(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlatformMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlatform>>>
    export type UpdatePlatformMutationBody = UpdatePlatformRequest
    export type UpdatePlatformMutationError = ErrorType<void>

    /**
 * @summary Updates a Platform identified by Platform id.
 */
export const useUpdatePlatform = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatform>>, TError,{platformId: string;data: UpdatePlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePlatform>>,
        TError,
        {platformId: string;data: UpdatePlatformRequest},
        TContext
      > => {
      return useMutation(getUpdatePlatformMutationOptions(options));
    }
    /**
 * @summary Gets a single Platform by id without user-specific data filtering.
The list of roles within `AuthorizeAdminRole` is supposed to be synced with
the list of roles specified on the RepeatMD.AdminApp.Controllers.Api.AdminUsersController
 */
export const getPlatformData = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}/data`, method: 'GET', signal
    },
      );
    }
  



export const getGetPlatformDataQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/data`
    ] as const;
    }

    
export const getGetPlatformDataQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformData>>, TError = ErrorType<void>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformDataQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformData>>> = ({ signal }) => getPlatformData(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformDataQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformData>>>
export type GetPlatformDataQueryError = ErrorType<void>


/**
 * @summary Gets a single Platform by id without user-specific data filtering.
The list of roles within `AuthorizeAdminRole` is supposed to be synced with
the list of roles specified on the RepeatMD.AdminApp.Controllers.Api.AdminUsersController
 */

export function useGetPlatformData<TData = Awaited<ReturnType<typeof getPlatformData>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformData>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformDataQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Gets available platform pricing tiers.
 */
export const getPricingTiers = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformPricingTierModel[]>(
      {url: `/api/v1/platforms/pricing-tiers`, method: 'GET', signal
    },
      );
    }
  



export const getGetPricingTiersQueryKey = () => {
    return [
    `/api/v1/platforms/pricing-tiers`
    ] as const;
    }

    
export const getGetPricingTiersQueryOptions = <TData = Awaited<ReturnType<typeof getPricingTiers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPricingTiersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPricingTiers>>> = ({ signal }) => getPricingTiers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPricingTiersQueryResult = NonNullable<Awaited<ReturnType<typeof getPricingTiers>>>
export type GetPricingTiersQueryError = ErrorType<unknown>


/**
 * @summary Gets available platform pricing tiers.
 */

export function useGetPricingTiers<TData = Awaited<ReturnType<typeof getPricingTiers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPricingTiers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPricingTiersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Update PlatformSettings for a particular Platform.
 */
export const updatePlatformSettings = (
    platformId: string,
    updatePlatformSettingsRequest: UpdatePlatformSettingsRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformSettingsUpdatedEvent>(
      {url: `/api/v1/platforms/${platformId}/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformSettingsRequest, signal
    },
      );
    }
  


export const getUpdatePlatformSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformSettings>>, TError,{platformId: string;data: UpdatePlatformSettingsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlatformSettings>>, TError,{platformId: string;data: UpdatePlatformSettingsRequest}, TContext> => {

const mutationKey = ['updatePlatformSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlatformSettings>>, {platformId: string;data: UpdatePlatformSettingsRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  updatePlatformSettings(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlatformSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlatformSettings>>>
    export type UpdatePlatformSettingsMutationBody = UpdatePlatformSettingsRequest
    export type UpdatePlatformSettingsMutationError = ErrorType<void>

    /**
 * @summary Update PlatformSettings for a particular Platform.
 */
export const useUpdatePlatformSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformSettings>>, TError,{platformId: string;data: UpdatePlatformSettingsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePlatformSettings>>,
        TError,
        {platformId: string;data: UpdatePlatformSettingsRequest},
        TContext
      > => {
      return useMutation(getUpdatePlatformSettingsMutationOptions(options));
    }
    /**
 * @summary Update checkout tip settings for a platform. Practice-level admins can use this endpoint;
the full M:RepeatMD.AdminApp.Controllers.Api.PlatformsController.UpdatePlatformSettings(System.Guid,RepeatMD.Shared.Commands.Admin.Models.RequestModels.UpdatePlatformSettingsRequest,RepeatMD.Shared.Commands.Admin.Platforms.UpdatePlatformSettingsCommand) route remains restricted to RepeatMD staff.
 */
export const updatePlatformTipSettings = (
    platformId: string,
    updatePlatformTipSettingsRequest: UpdatePlatformTipSettingsRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformSettingsUpdatedEvent>(
      {url: `/api/v1/platforms/${platformId}/settings/tips`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformTipSettingsRequest, signal
    },
      );
    }
  


export const getUpdatePlatformTipSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformTipSettings>>, TError,{platformId: string;data: UpdatePlatformTipSettingsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlatformTipSettings>>, TError,{platformId: string;data: UpdatePlatformTipSettingsRequest}, TContext> => {

const mutationKey = ['updatePlatformTipSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlatformTipSettings>>, {platformId: string;data: UpdatePlatformTipSettingsRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  updatePlatformTipSettings(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlatformTipSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlatformTipSettings>>>
    export type UpdatePlatformTipSettingsMutationBody = UpdatePlatformTipSettingsRequest
    export type UpdatePlatformTipSettingsMutationError = ErrorType<void>

    /**
 * @summary Update checkout tip settings for a platform. Practice-level admins can use this endpoint;
the full M:RepeatMD.AdminApp.Controllers.Api.PlatformsController.UpdatePlatformSettings(System.Guid,RepeatMD.Shared.Commands.Admin.Models.RequestModels.UpdatePlatformSettingsRequest,RepeatMD.Shared.Commands.Admin.Platforms.UpdatePlatformSettingsCommand) route remains restricted to RepeatMD staff.
 */
export const useUpdatePlatformTipSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformTipSettings>>, TError,{platformId: string;data: UpdatePlatformTipSettingsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePlatformTipSettings>>,
        TError,
        {platformId: string;data: UpdatePlatformTipSettingsRequest},
        TContext
      > => {
      return useMutation(getUpdatePlatformTipSettingsMutationOptions(options));
    }
    /**
 * @summary Update the fee configuration (service fee and processing fee amounts and obligations) for a platform.
Updates platform_settings and all active platform_payment_processors.
 */
export const updatePlatformFeeConfiguration = (
    platformId: string,
    updatePlatformFeeConfigurationRequest: UpdatePlatformFeeConfigurationRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/fee-configuration`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformFeeConfigurationRequest, signal
    },
      );
    }
  


export const getUpdatePlatformFeeConfigurationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformFeeConfiguration>>, TError,{platformId: string;data: UpdatePlatformFeeConfigurationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlatformFeeConfiguration>>, TError,{platformId: string;data: UpdatePlatformFeeConfigurationRequest}, TContext> => {

const mutationKey = ['updatePlatformFeeConfiguration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlatformFeeConfiguration>>, {platformId: string;data: UpdatePlatformFeeConfigurationRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  updatePlatformFeeConfiguration(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlatformFeeConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlatformFeeConfiguration>>>
    export type UpdatePlatformFeeConfigurationMutationBody = UpdatePlatformFeeConfigurationRequest
    export type UpdatePlatformFeeConfigurationMutationError = ErrorType<void>

    /**
 * @summary Update the fee configuration (service fee and processing fee amounts and obligations) for a platform.
Updates platform_settings and all active platform_payment_processors.
 */
export const useUpdatePlatformFeeConfiguration = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformFeeConfiguration>>, TError,{platformId: string;data: UpdatePlatformFeeConfigurationRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePlatformFeeConfiguration>>,
        TError,
        {platformId: string;data: UpdatePlatformFeeConfigurationRequest},
        TContext
      > => {
      return useMutation(getUpdatePlatformFeeConfigurationMutationOptions(options));
    }
    /**
 * @summary Update PlatformDomain for a particular Platform.
 */
export const updatePlatformDomain = (
    platformId: string,
    updatePlatformDomainRequest: UpdatePlatformDomainRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}/domain`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformDomainRequest, signal
    },
      );
    }
  


export const getUpdatePlatformDomainMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformDomain>>, TError,{platformId: string;data: UpdatePlatformDomainRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlatformDomain>>, TError,{platformId: string;data: UpdatePlatformDomainRequest}, TContext> => {

const mutationKey = ['updatePlatformDomain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlatformDomain>>, {platformId: string;data: UpdatePlatformDomainRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  updatePlatformDomain(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlatformDomainMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlatformDomain>>>
    export type UpdatePlatformDomainMutationBody = UpdatePlatformDomainRequest
    export type UpdatePlatformDomainMutationError = ErrorType<void>

    /**
 * @summary Update PlatformDomain for a particular Platform.
 */
export const useUpdatePlatformDomain = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformDomain>>, TError,{platformId: string;data: UpdatePlatformDomainRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePlatformDomain>>,
        TError,
        {platformId: string;data: UpdatePlatformDomainRequest},
        TContext
      > => {
      return useMutation(getUpdatePlatformDomainMutationOptions(options));
    }
    /**
 * @summary Regenerates a platform's short links and re-queues its compensation calculation.
 */
export const regeneratePlatformShortLinks = (
    platformId: string,
    params?: RegeneratePlatformShortLinksParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayCreatedPlatformResponse>(
      {url: `/api/v1/platforms/${platformId}/short-links/regenerate`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getRegeneratePlatformShortLinksMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regeneratePlatformShortLinks>>, TError,{platformId: string;params?: RegeneratePlatformShortLinksParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regeneratePlatformShortLinks>>, TError,{platformId: string;params?: RegeneratePlatformShortLinksParams}, TContext> => {

const mutationKey = ['regeneratePlatformShortLinks'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regeneratePlatformShortLinks>>, {platformId: string;params?: RegeneratePlatformShortLinksParams}> = (props) => {
          const {platformId,params} = props ?? {};

          return  regeneratePlatformShortLinks(platformId,params,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RegeneratePlatformShortLinksMutationResult = NonNullable<Awaited<ReturnType<typeof regeneratePlatformShortLinks>>>
    
    export type RegeneratePlatformShortLinksMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Regenerates a platform's short links and re-queues its compensation calculation.
 */
export const useRegeneratePlatformShortLinks = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regeneratePlatformShortLinks>>, TError,{platformId: string;params?: RegeneratePlatformShortLinksParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof regeneratePlatformShortLinks>>,
        TError,
        {platformId: string;params?: RegeneratePlatformShortLinksParams},
        TContext
      > => {
      return useMutation(getRegeneratePlatformShortLinksMutationOptions(options));
    }
    /**
 * @summary Retrieves the configured domains for a platform.
 */
export const getPlatformDomains = (
    platformId: string,
    params?: GetPlatformDomainsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayPlatformDomainResponse[]>(
      {url: `/api/v1/platforms/${platformId}/domains`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetPlatformDomainsQueryKey = (platformId: string,
    params?: GetPlatformDomainsParams,) => {
    return [
    `/api/v1/platforms/${platformId}/domains`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetPlatformDomainsQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformDomains>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: GetPlatformDomainsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformDomainsQueryKey(platformId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformDomains>>> = ({ signal }) => getPlatformDomains(platformId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformDomainsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformDomains>>>
export type GetPlatformDomainsQueryError = ErrorType<ProblemDetails>


/**
 * @summary Retrieves the configured domains for a platform.
 */

export function useGetPlatformDomains<TData = Awaited<ReturnType<typeof getPlatformDomains>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetPlatformDomainsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformDomains>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformDomainsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Requests and provisions a new custom domain for a platform.
 */
export const requestCustomDomain = (
    platformId: string,
    requestCustomDomainForPlatformRequest: RequestCustomDomainForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<unknown>(
      {url: `/api/v1/platforms/${platformId}/custom-domains`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestCustomDomainForPlatformRequest, signal
    },
      );
    }
  


export const getRequestCustomDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCustomDomain>>, TError,{platformId: string;data: RequestCustomDomainForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof requestCustomDomain>>, TError,{platformId: string;data: RequestCustomDomainForPlatformRequest}, TContext> => {

const mutationKey = ['requestCustomDomain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestCustomDomain>>, {platformId: string;data: RequestCustomDomainForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  requestCustomDomain(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RequestCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof requestCustomDomain>>>
    export type RequestCustomDomainMutationBody = RequestCustomDomainForPlatformRequest
    export type RequestCustomDomainMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Requests and provisions a new custom domain for a platform.
 */
export const useRequestCustomDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCustomDomain>>, TError,{platformId: string;data: RequestCustomDomainForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestCustomDomain>>,
        TError,
        {platformId: string;data: RequestCustomDomainForPlatformRequest},
        TContext
      > => {
      return useMutation(getRequestCustomDomainMutationOptions(options));
    }
    /**
 * @summary Starts the guided Basic Smart Site domain setup for an eligible platform administrator.
 */
export const setupBasicSmartSite = (
    platformId: string,
    requestCustomDomainForPlatformRequest: RequestCustomDomainForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayBasicSmartSiteLaunchConfigurationResponse>(
      {url: `/api/v1/platforms/${platformId}/basic-smart-site/setup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestCustomDomainForPlatformRequest, signal
    },
      );
    }
  


export const getSetupBasicSmartSiteMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupBasicSmartSite>>, TError,{platformId: string;data: RequestCustomDomainForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setupBasicSmartSite>>, TError,{platformId: string;data: RequestCustomDomainForPlatformRequest}, TContext> => {

const mutationKey = ['setupBasicSmartSite'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setupBasicSmartSite>>, {platformId: string;data: RequestCustomDomainForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  setupBasicSmartSite(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetupBasicSmartSiteMutationResult = NonNullable<Awaited<ReturnType<typeof setupBasicSmartSite>>>
    export type SetupBasicSmartSiteMutationBody = RequestCustomDomainForPlatformRequest
    export type SetupBasicSmartSiteMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Starts the guided Basic Smart Site domain setup for an eligible platform administrator.
 */
export const useSetupBasicSmartSite = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupBasicSmartSite>>, TError,{platformId: string;data: RequestCustomDomainForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setupBasicSmartSite>>,
        TError,
        {platformId: string;data: RequestCustomDomainForPlatformRequest},
        TContext
      > => {
      return useMutation(getSetupBasicSmartSiteMutationOptions(options));
    }
    /**
 * @summary Checks and resumes an existing custom domain without requiring a DNS automation callback.
 */
export const resumeCustomDomainActivation = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}/resume`, method: 'POST', signal
    },
      );
    }
  


export const getResumeCustomDomainActivationMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeCustomDomainActivation>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resumeCustomDomainActivation>>, TError,{platformId: string;platformDomainId: string}, TContext> => {

const mutationKey = ['resumeCustomDomainActivation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resumeCustomDomainActivation>>, {platformId: string;platformDomainId: string}> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  resumeCustomDomainActivation(platformId,platformDomainId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ResumeCustomDomainActivationMutationResult = NonNullable<Awaited<ReturnType<typeof resumeCustomDomainActivation>>>
    
    export type ResumeCustomDomainActivationMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Checks and resumes an existing custom domain without requiring a DNS automation callback.
 */
export const useResumeCustomDomainActivation = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeCustomDomainActivation>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof resumeCustomDomainActivation>>,
        TError,
        {platformId: string;platformDomainId: string},
        TContext
      > => {
      return useMutation(getResumeCustomDomainActivationMutationOptions(options));
    }
    /**
 * @summary Verifies DNS ownership and certificate issuance for a platform's pending custom domain.
 */
export const verifyCustomDomain = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<unknown>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}/verify`, method: 'POST', signal
    },
      );
    }
  


export const getVerifyCustomDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verifyCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext> => {

const mutationKey = ['verifyCustomDomain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyCustomDomain>>, {platformId: string;platformDomainId: string}> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  verifyCustomDomain(platformId,platformDomainId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof verifyCustomDomain>>>
    
    export type VerifyCustomDomainMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Verifies DNS ownership and certificate issuance for a platform's pending custom domain.
 */
export const useVerifyCustomDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyCustomDomain>>,
        TError,
        {platformId: string;platformDomainId: string},
        TContext
      > => {
      return useMutation(getVerifyCustomDomainMutationOptions(options));
    }
    /**
 * @summary Deploys a verified custom domain so its routing can be activated.
 */
export const deployCustomDomain = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<unknown>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}/deploy`, method: 'POST', signal
    },
      );
    }
  


export const getDeployCustomDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deployCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deployCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext> => {

const mutationKey = ['deployCustomDomain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deployCustomDomain>>, {platformId: string;platformDomainId: string}> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  deployCustomDomain(platformId,platformDomainId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeployCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof deployCustomDomain>>>
    
    export type DeployCustomDomainMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Deploys a verified custom domain so its routing can be activated.
 */
export const useDeployCustomDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deployCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deployCustomDomain>>,
        TError,
        {platformId: string;platformDomainId: string},
        TContext
      > => {
      return useMutation(getDeployCustomDomainMutationOptions(options));
    }
    /**
 * @summary Verifies that a deployed custom domain is routing correctly and activates it.
 */
export const verifyRoutingCustomDomain = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<unknown>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}/verify-routing`, method: 'POST', signal
    },
      );
    }
  


export const getVerifyRoutingCustomDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyRoutingCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verifyRoutingCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext> => {

const mutationKey = ['verifyRoutingCustomDomain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyRoutingCustomDomain>>, {platformId: string;platformDomainId: string}> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  verifyRoutingCustomDomain(platformId,platformDomainId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyRoutingCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof verifyRoutingCustomDomain>>>
    
    export type VerifyRoutingCustomDomainMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Verifies that a deployed custom domain is routing correctly and activates it.
 */
export const useVerifyRoutingCustomDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyRoutingCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyRoutingCustomDomain>>,
        TError,
        {platformId: string;platformDomainId: string},
        TContext
      > => {
      return useMutation(getVerifyRoutingCustomDomainMutationOptions(options));
    }
    /**
 * @summary Confirms staff-reviewed routing evidence and activates the domain only after fresh checks pass.
 */
export const confirmCustomDomainRouting = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}/confirm-routing`, method: 'POST', signal
    },
      );
    }
  


export const getConfirmCustomDomainRoutingMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCustomDomainRouting>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmCustomDomainRouting>>, TError,{platformId: string;platformDomainId: string}, TContext> => {

const mutationKey = ['confirmCustomDomainRouting'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmCustomDomainRouting>>, {platformId: string;platformDomainId: string}> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  confirmCustomDomainRouting(platformId,platformDomainId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmCustomDomainRoutingMutationResult = NonNullable<Awaited<ReturnType<typeof confirmCustomDomainRouting>>>
    
    export type ConfirmCustomDomainRoutingMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Confirms staff-reviewed routing evidence and activates the domain only after fresh checks pass.
 */
export const useConfirmCustomDomainRouting = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCustomDomainRouting>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmCustomDomainRouting>>,
        TError,
        {platformId: string;platformDomainId: string},
        TContext
      > => {
      return useMutation(getConfirmCustomDomainRoutingMutationOptions(options));
    }
    /**
 * @summary Permanently deletes a disabled custom domain from a platform.
 */
export const deleteCustomDomain = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<unknown>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}/delete`, method: 'POST', signal
    },
      );
    }
  


export const getDeleteCustomDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext> => {

const mutationKey = ['deleteCustomDomain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomDomain>>, {platformId: string;platformDomainId: string}> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  deleteCustomDomain(platformId,platformDomainId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomDomain>>>
    
    export type DeleteCustomDomainMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Permanently deletes a disabled custom domain from a platform.
 */
export const useDeleteCustomDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomDomain>>,
        TError,
        {platformId: string;platformDomainId: string},
        TContext
      > => {
      return useMutation(getDeleteCustomDomainMutationOptions(options));
    }
    /**
 * @summary Disables an active custom domain for a platform.
 */
export const disableCustomDomain = (
    platformId: string,
    platformDomainId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<unknown>(
      {url: `/api/v1/platforms/${platformId}/custom-domains/${platformDomainId}`, method: 'DELETE', signal
    },
      );
    }
  


export const getDisableCustomDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext> => {

const mutationKey = ['disableCustomDomain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableCustomDomain>>, {platformId: string;platformDomainId: string}> = (props) => {
          const {platformId,platformDomainId} = props ?? {};

          return  disableCustomDomain(platformId,platformDomainId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DisableCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof disableCustomDomain>>>
    
    export type DisableCustomDomainMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Disables an active custom domain for a platform.
 */
export const useDisableCustomDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableCustomDomain>>, TError,{platformId: string;platformDomainId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof disableCustomDomain>>,
        TError,
        {platformId: string;platformDomainId: string},
        TContext
      > => {
      return useMutation(getDisableCustomDomainMutationOptions(options));
    }
    /**
 * @summary Creates a new PlatformLocation.
 */
export const platformsCreatePlatformLocation = (
    platformId: string,
    updatePlatformLocationRequest: UpdatePlatformLocationRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}/locations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformLocationRequest, signal
    },
      );
    }
  


export const getPlatformsCreatePlatformLocationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsCreatePlatformLocation>>, TError,{platformId: string;data: UpdatePlatformLocationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsCreatePlatformLocation>>, TError,{platformId: string;data: UpdatePlatformLocationRequest}, TContext> => {

const mutationKey = ['platformsCreatePlatformLocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsCreatePlatformLocation>>, {platformId: string;data: UpdatePlatformLocationRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsCreatePlatformLocation(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformsCreatePlatformLocationMutationResult = NonNullable<Awaited<ReturnType<typeof platformsCreatePlatformLocation>>>
    export type PlatformsCreatePlatformLocationMutationBody = UpdatePlatformLocationRequest
    export type PlatformsCreatePlatformLocationMutationError = ErrorType<void>

    /**
 * @summary Creates a new PlatformLocation.
 */
export const usePlatformsCreatePlatformLocation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsCreatePlatformLocation>>, TError,{platformId: string;data: UpdatePlatformLocationRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformsCreatePlatformLocation>>,
        TError,
        {platformId: string;data: UpdatePlatformLocationRequest},
        TContext
      > => {
      return useMutation(getPlatformsCreatePlatformLocationMutationOptions(options));
    }
    /**
 * @summary Updates a PlatformLocation identified by PlatformLocation id.
 */
export const platformsUpdatePlatformLocation = (
    platformId: string,
    locationId: string,
    updatePlatformLocationRequest: UpdatePlatformLocationRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayCreatedPlatformResponse>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformLocationRequest, signal
    },
      );
    }
  


export const getPlatformsUpdatePlatformLocationMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsUpdatePlatformLocation>>, TError,{platformId: string;locationId: string;data: UpdatePlatformLocationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsUpdatePlatformLocation>>, TError,{platformId: string;locationId: string;data: UpdatePlatformLocationRequest}, TContext> => {

const mutationKey = ['platformsUpdatePlatformLocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsUpdatePlatformLocation>>, {platformId: string;locationId: string;data: UpdatePlatformLocationRequest}> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  platformsUpdatePlatformLocation(platformId,locationId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformsUpdatePlatformLocationMutationResult = NonNullable<Awaited<ReturnType<typeof platformsUpdatePlatformLocation>>>
    export type PlatformsUpdatePlatformLocationMutationBody = UpdatePlatformLocationRequest
    export type PlatformsUpdatePlatformLocationMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Updates a PlatformLocation identified by PlatformLocation id.
 */
export const usePlatformsUpdatePlatformLocation = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsUpdatePlatformLocation>>, TError,{platformId: string;locationId: string;data: UpdatePlatformLocationRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformsUpdatePlatformLocation>>,
        TError,
        {platformId: string;locationId: string;data: UpdatePlatformLocationRequest},
        TContext
      > => {
      return useMutation(getPlatformsUpdatePlatformLocationMutationOptions(options));
    }
    /**
 * @summary Deletes a PlatformLocation identified by PlatformLocation id.
 */
export const deletePlatformLocation = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}`, method: 'DELETE', signal
    },
      );
    }
  


export const getDeletePlatformLocationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlatformLocation>>, TError,{platformId: string;locationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePlatformLocation>>, TError,{platformId: string;locationId: string}, TContext> => {

const mutationKey = ['deletePlatformLocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePlatformLocation>>, {platformId: string;locationId: string}> = (props) => {
          const {platformId,locationId} = props ?? {};

          return  deletePlatformLocation(platformId,locationId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePlatformLocationMutationResult = NonNullable<Awaited<ReturnType<typeof deletePlatformLocation>>>
    
    export type DeletePlatformLocationMutationError = ErrorType<void>

    /**
 * @summary Deletes a PlatformLocation identified by PlatformLocation id.
 */
export const useDeletePlatformLocation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlatformLocation>>, TError,{platformId: string;locationId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePlatformLocation>>,
        TError,
        {platformId: string;locationId: string},
        TContext
      > => {
      return useMutation(getDeletePlatformLocationMutationOptions(options));
    }
    /**
 * @summary Activates a PlatformLocation. This operation is restricted to RepeatMD administrators.
 */
export const activatePlatformLocation = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/activate`, method: 'PUT', signal
    },
      );
    }
  


export const getActivatePlatformLocationMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePlatformLocation>>, TError,{platformId: string;locationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activatePlatformLocation>>, TError,{platformId: string;locationId: string}, TContext> => {

const mutationKey = ['activatePlatformLocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activatePlatformLocation>>, {platformId: string;locationId: string}> = (props) => {
          const {platformId,locationId} = props ?? {};

          return  activatePlatformLocation(platformId,locationId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ActivatePlatformLocationMutationResult = NonNullable<Awaited<ReturnType<typeof activatePlatformLocation>>>
    
    export type ActivatePlatformLocationMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Activates a PlatformLocation. This operation is restricted to RepeatMD administrators.
 */
export const useActivatePlatformLocation = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePlatformLocation>>, TError,{platformId: string;locationId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof activatePlatformLocation>>,
        TError,
        {platformId: string;locationId: string},
        TContext
      > => {
      return useMutation(getActivatePlatformLocationMutationOptions(options));
    }
    /**
 * @summary Deactivates a PlatformLocation. This operation is restricted to RepeatMD administrators.
 */
export const deactivatePlatformLocation = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/deactivate`, method: 'PUT', signal
    },
      );
    }
  


export const getDeactivatePlatformLocationMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivatePlatformLocation>>, TError,{platformId: string;locationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivatePlatformLocation>>, TError,{platformId: string;locationId: string}, TContext> => {

const mutationKey = ['deactivatePlatformLocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivatePlatformLocation>>, {platformId: string;locationId: string}> = (props) => {
          const {platformId,locationId} = props ?? {};

          return  deactivatePlatformLocation(platformId,locationId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivatePlatformLocationMutationResult = NonNullable<Awaited<ReturnType<typeof deactivatePlatformLocation>>>
    
    export type DeactivatePlatformLocationMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Deactivates a PlatformLocation. This operation is restricted to RepeatMD administrators.
 */
export const useDeactivatePlatformLocation = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivatePlatformLocation>>, TError,{platformId: string;locationId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deactivatePlatformLocation>>,
        TError,
        {platformId: string;locationId: string},
        TContext
      > => {
      return useMutation(getDeactivatePlatformLocationMutationOptions(options));
    }
    /**
 * @summary Retrieves operating hours for a platform location.
 */
export const getPlatformLocationOperatingHours = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayOperatingHoursForPlatformLocation>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/operating-hours`, method: 'GET', signal
    },
      );
    }
  



export const getGetPlatformLocationOperatingHoursQueryKey = (platformId: string,
    locationId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/locations/${locationId}/operating-hours`
    ] as const;
    }

    
export const getGetPlatformLocationOperatingHoursQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError = ErrorType<void>>(platformId: string,
    locationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformLocationOperatingHoursQueryKey(platformId,locationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>> = ({ signal }) => getPlatformLocationOperatingHours(platformId,locationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId && locationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformLocationOperatingHoursQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>>
export type GetPlatformLocationOperatingHoursQueryError = ErrorType<void>


/**
 * @summary Retrieves operating hours for a platform location.
 */

export function useGetPlatformLocationOperatingHours<TData = Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError = ErrorType<void>>(
 platformId: string,
    locationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationOperatingHours>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformLocationOperatingHoursQueryOptions(platformId,locationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Updates operating hours for a platform location.
 */
export const setPlatformLocationOperatingHours = (
    platformId: string,
    locationId: string,
    setOperatingHoursForPlatformLocationRequest: SetOperatingHoursForPlatformLocationRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/operating-hours`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setOperatingHoursForPlatformLocationRequest, signal
    },
      );
    }
  


export const getSetPlatformLocationOperatingHoursMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPlatformLocationOperatingHours>>, TError,{platformId: string;locationId: string;data: SetOperatingHoursForPlatformLocationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setPlatformLocationOperatingHours>>, TError,{platformId: string;locationId: string;data: SetOperatingHoursForPlatformLocationRequest}, TContext> => {

const mutationKey = ['setPlatformLocationOperatingHours'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPlatformLocationOperatingHours>>, {platformId: string;locationId: string;data: SetOperatingHoursForPlatformLocationRequest}> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setPlatformLocationOperatingHours(platformId,locationId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetPlatformLocationOperatingHoursMutationResult = NonNullable<Awaited<ReturnType<typeof setPlatformLocationOperatingHours>>>
    export type SetPlatformLocationOperatingHoursMutationBody = SetOperatingHoursForPlatformLocationRequest
    export type SetPlatformLocationOperatingHoursMutationError = ErrorType<void>

    /**
 * @summary Updates operating hours for a platform location.
 */
export const useSetPlatformLocationOperatingHours = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPlatformLocationOperatingHours>>, TError,{platformId: string;locationId: string;data: SetOperatingHoursForPlatformLocationRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setPlatformLocationOperatingHours>>,
        TError,
        {platformId: string;locationId: string;data: SetOperatingHoursForPlatformLocationRequest},
        TContext
      > => {
      return useMutation(getSetPlatformLocationOperatingHoursMutationOptions(options));
    }
    /**
 * @summary Gets the timezones for all locations of a Platform.
 */
export const getPlatformLocationsTimezones = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformLocationsTimezonesResult[]>(
      {url: `/api/v1/platforms/${platformId}/locations/timezones`, method: 'GET', signal
    },
      );
    }
  



export const getGetPlatformLocationsTimezonesQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/locations/timezones`
    ] as const;
    }

    
export const getGetPlatformLocationsTimezonesQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError = ErrorType<void>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformLocationsTimezonesQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>> = ({ signal }) => getPlatformLocationsTimezones(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformLocationsTimezonesQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>>
export type GetPlatformLocationsTimezonesQueryError = ErrorType<void>


/**
 * @summary Gets the timezones for all locations of a Platform.
 */

export function useGetPlatformLocationsTimezones<TData = Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsTimezones>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformLocationsTimezonesQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Gets statistic regarding transactions of a Platform.
 */
export const getPlatformTransactionStats = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<GetPlatformTransactionsStatsResult>(
      {url: `/api/v1/platforms/${platformId}/transactions-stats`, method: 'GET', signal
    },
      );
    }
  



export const getGetPlatformTransactionStatsQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/transactions-stats`
    ] as const;
    }

    
export const getGetPlatformTransactionStatsQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError = ErrorType<void>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformTransactionStatsQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformTransactionStats>>> = ({ signal }) => getPlatformTransactionStats(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformTransactionStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformTransactionStats>>>
export type GetPlatformTransactionStatsQueryError = ErrorType<void>


/**
 * @summary Gets statistic regarding transactions of a Platform.
 */

export function useGetPlatformTransactionStats<TData = Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformTransactionStats>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformTransactionStatsQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Gets statistic regarding payouts of a Platform.
 */
export const platformsGetPlatformPayoutsStats = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<GetPlatformPayoutsStatsResult>(
      {url: `/api/v1/platforms/${platformId}/payouts-stats`, method: 'GET', signal
    },
      );
    }
  



export const getPlatformsGetPlatformPayoutsStatsQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/payouts-stats`
    ] as const;
    }

    
export const getPlatformsGetPlatformPayoutsStatsQueryOptions = <TData = Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError = ErrorType<void>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformsGetPlatformPayoutsStatsQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>> = ({ signal }) => platformsGetPlatformPayoutsStats(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData> & { queryKey: QueryKey }
}

export type PlatformsGetPlatformPayoutsStatsQueryResult = NonNullable<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>>
export type PlatformsGetPlatformPayoutsStatsQueryError = ErrorType<void>


/**
 * @summary Gets statistic regarding payouts of a Platform.
 */

export function usePlatformsGetPlatformPayoutsStats<TData = Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof platformsGetPlatformPayoutsStats>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPlatformsGetPlatformPayoutsStatsQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Associates a Salesforce ID with a Platform.
 */
export const platformsAssociateSalesforceIdToPlatform = (
    platformId: string,
    associateSalesforceIdToPlatformRequest: AssociateSalesforceIdToPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<SalesforceIdAssociatedToPlatformEvent>(
      {url: `/api/v1/platforms/${platformId}/associate-salesforce-id`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: associateSalesforceIdToPlatformRequest, signal
    },
      );
    }
  


export const getPlatformsAssociateSalesforceIdToPlatformMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsAssociateSalesforceIdToPlatform>>, TError,{platformId: string;data: AssociateSalesforceIdToPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsAssociateSalesforceIdToPlatform>>, TError,{platformId: string;data: AssociateSalesforceIdToPlatformRequest}, TContext> => {

const mutationKey = ['platformsAssociateSalesforceIdToPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsAssociateSalesforceIdToPlatform>>, {platformId: string;data: AssociateSalesforceIdToPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsAssociateSalesforceIdToPlatform(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformsAssociateSalesforceIdToPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformsAssociateSalesforceIdToPlatform>>>
    export type PlatformsAssociateSalesforceIdToPlatformMutationBody = AssociateSalesforceIdToPlatformRequest
    export type PlatformsAssociateSalesforceIdToPlatformMutationError = ErrorType<void>

    /**
 * @summary Associates a Salesforce ID with a Platform.
 */
export const usePlatformsAssociateSalesforceIdToPlatform = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsAssociateSalesforceIdToPlatform>>, TError,{platformId: string;data: AssociateSalesforceIdToPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformsAssociateSalesforceIdToPlatform>>,
        TError,
        {platformId: string;data: AssociateSalesforceIdToPlatformRequest},
        TContext
      > => {
      return useMutation(getPlatformsAssociateSalesforceIdToPlatformMutationOptions(options));
    }
    /**
 * @summary Associates a Salesforce Account ID with a Platform.
 */
export const platformsAssociateSalesforceAccountIdToPlatform = (
    platformId: string,
    associateSalesforceAccountIdToPlatformRequest: AssociateSalesforceAccountIdToPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<SalesforceAccountIdAssociatedToPlatformEvent>(
      {url: `/api/v1/platforms/${platformId}/associate-salesforce-account-id`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: associateSalesforceAccountIdToPlatformRequest, signal
    },
      );
    }
  


export const getPlatformsAssociateSalesforceAccountIdToPlatformMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsAssociateSalesforceAccountIdToPlatform>>, TError,{platformId: string;data: AssociateSalesforceAccountIdToPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsAssociateSalesforceAccountIdToPlatform>>, TError,{platformId: string;data: AssociateSalesforceAccountIdToPlatformRequest}, TContext> => {

const mutationKey = ['platformsAssociateSalesforceAccountIdToPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsAssociateSalesforceAccountIdToPlatform>>, {platformId: string;data: AssociateSalesforceAccountIdToPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsAssociateSalesforceAccountIdToPlatform(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformsAssociateSalesforceAccountIdToPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformsAssociateSalesforceAccountIdToPlatform>>>
    export type PlatformsAssociateSalesforceAccountIdToPlatformMutationBody = AssociateSalesforceAccountIdToPlatformRequest
    export type PlatformsAssociateSalesforceAccountIdToPlatformMutationError = ErrorType<void>

    /**
 * @summary Associates a Salesforce Account ID with a Platform.
 */
export const usePlatformsAssociateSalesforceAccountIdToPlatform = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsAssociateSalesforceAccountIdToPlatform>>, TError,{platformId: string;data: AssociateSalesforceAccountIdToPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformsAssociateSalesforceAccountIdToPlatform>>,
        TError,
        {platformId: string;data: AssociateSalesforceAccountIdToPlatformRequest},
        TContext
      > => {
      return useMutation(getPlatformsAssociateSalesforceAccountIdToPlatformMutationOptions(options));
    }
    /**
 * @summary Sets the Salesforce parent Account Id for a Platform.
 */
export const platformsSetSalesforceParentAccountIdForPlatform = (
    platformId: string,
    setSalesforceParentAccountIdForPlatformRequest: SetSalesforceParentAccountIdForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/set-salesforce-parent-account-id`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setSalesforceParentAccountIdForPlatformRequest, signal
    },
      );
    }
  


export const getPlatformsSetSalesforceParentAccountIdForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsSetSalesforceParentAccountIdForPlatform>>, TError,{platformId: string;data: SetSalesforceParentAccountIdForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsSetSalesforceParentAccountIdForPlatform>>, TError,{platformId: string;data: SetSalesforceParentAccountIdForPlatformRequest}, TContext> => {

const mutationKey = ['platformsSetSalesforceParentAccountIdForPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsSetSalesforceParentAccountIdForPlatform>>, {platformId: string;data: SetSalesforceParentAccountIdForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsSetSalesforceParentAccountIdForPlatform(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformsSetSalesforceParentAccountIdForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformsSetSalesforceParentAccountIdForPlatform>>>
    export type PlatformsSetSalesforceParentAccountIdForPlatformMutationBody = SetSalesforceParentAccountIdForPlatformRequest
    export type PlatformsSetSalesforceParentAccountIdForPlatformMutationError = ErrorType<unknown>

    /**
 * @summary Sets the Salesforce parent Account Id for a Platform.
 */
export const usePlatformsSetSalesforceParentAccountIdForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsSetSalesforceParentAccountIdForPlatform>>, TError,{platformId: string;data: SetSalesforceParentAccountIdForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformsSetSalesforceParentAccountIdForPlatform>>,
        TError,
        {platformId: string;data: SetSalesforceParentAccountIdForPlatformRequest},
        TContext
      > => {
      return useMutation(getPlatformsSetSalesforceParentAccountIdForPlatformMutationOptions(options));
    }
    /**
 * @summary Sets the Salesforce RepeatMD Opportunity Id for a Platform.
 */
export const platformsSetRepeatMdOpportunityForPlatform = (
    platformId: string,
    setRepeatMdOpportunityForPlatformRequest: SetRepeatMdOpportunityForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/set-repeatmd-opportunity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setRepeatMdOpportunityForPlatformRequest, signal
    },
      );
    }
  


export const getPlatformsSetRepeatMdOpportunityForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsSetRepeatMdOpportunityForPlatform>>, TError,{platformId: string;data: SetRepeatMdOpportunityForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsSetRepeatMdOpportunityForPlatform>>, TError,{platformId: string;data: SetRepeatMdOpportunityForPlatformRequest}, TContext> => {

const mutationKey = ['platformsSetRepeatMdOpportunityForPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsSetRepeatMdOpportunityForPlatform>>, {platformId: string;data: SetRepeatMdOpportunityForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsSetRepeatMdOpportunityForPlatform(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformsSetRepeatMdOpportunityForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformsSetRepeatMdOpportunityForPlatform>>>
    export type PlatformsSetRepeatMdOpportunityForPlatformMutationBody = SetRepeatMdOpportunityForPlatformRequest
    export type PlatformsSetRepeatMdOpportunityForPlatformMutationError = ErrorType<unknown>

    /**
 * @summary Sets the Salesforce RepeatMD Opportunity Id for a Platform.
 */
export const usePlatformsSetRepeatMdOpportunityForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsSetRepeatMdOpportunityForPlatform>>, TError,{platformId: string;data: SetRepeatMdOpportunityForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformsSetRepeatMdOpportunityForPlatform>>,
        TError,
        {platformId: string;data: SetRepeatMdOpportunityForPlatformRequest},
        TContext
      > => {
      return useMutation(getPlatformsSetRepeatMdOpportunityForPlatformMutationOptions(options));
    }
    /**
 * @summary Sets the Salesforce Ageless Opportunity Id for a Platform.
 */
export const platformsSetAgelessOpportunityForPlatform = (
    platformId: string,
    setAgelessOpportunityForPlatformRequest: SetAgelessOpportunityForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/set-ageless-opportunity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOpportunityForPlatformRequest, signal
    },
      );
    }
  


export const getPlatformsSetAgelessOpportunityForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsSetAgelessOpportunityForPlatform>>, TError,{platformId: string;data: SetAgelessOpportunityForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsSetAgelessOpportunityForPlatform>>, TError,{platformId: string;data: SetAgelessOpportunityForPlatformRequest}, TContext> => {

const mutationKey = ['platformsSetAgelessOpportunityForPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsSetAgelessOpportunityForPlatform>>, {platformId: string;data: SetAgelessOpportunityForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsSetAgelessOpportunityForPlatform(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformsSetAgelessOpportunityForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformsSetAgelessOpportunityForPlatform>>>
    export type PlatformsSetAgelessOpportunityForPlatformMutationBody = SetAgelessOpportunityForPlatformRequest
    export type PlatformsSetAgelessOpportunityForPlatformMutationError = ErrorType<unknown>

    /**
 * @summary Sets the Salesforce Ageless Opportunity Id for a Platform.
 */
export const usePlatformsSetAgelessOpportunityForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsSetAgelessOpportunityForPlatform>>, TError,{platformId: string;data: SetAgelessOpportunityForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformsSetAgelessOpportunityForPlatform>>,
        TError,
        {platformId: string;data: SetAgelessOpportunityForPlatformRequest},
        TContext
      > => {
      return useMutation(getPlatformsSetAgelessOpportunityForPlatformMutationOptions(options));
    }
    /**
 * @summary Associates a Practice Type with a Platform from Salesforce.
 */
export const platformsAssociatePracticeTypeToPlatform = (
    platformId: string,
    associatePracticeTypeToPlatformRequest: AssociatePracticeTypeToPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PracticeTypeAssociatedToPlatformEvent>(
      {url: `/api/v1/platforms/${platformId}/associate-practice-type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: associatePracticeTypeToPlatformRequest, signal
    },
      );
    }
  


export const getPlatformsAssociatePracticeTypeToPlatformMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsAssociatePracticeTypeToPlatform>>, TError,{platformId: string;data: AssociatePracticeTypeToPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof platformsAssociatePracticeTypeToPlatform>>, TError,{platformId: string;data: AssociatePracticeTypeToPlatformRequest}, TContext> => {

const mutationKey = ['platformsAssociatePracticeTypeToPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformsAssociatePracticeTypeToPlatform>>, {platformId: string;data: AssociatePracticeTypeToPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  platformsAssociatePracticeTypeToPlatform(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformsAssociatePracticeTypeToPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof platformsAssociatePracticeTypeToPlatform>>>
    export type PlatformsAssociatePracticeTypeToPlatformMutationBody = AssociatePracticeTypeToPlatformRequest
    export type PlatformsAssociatePracticeTypeToPlatformMutationError = ErrorType<void>

    /**
 * @summary Associates a Practice Type with a Platform from Salesforce.
 */
export const usePlatformsAssociatePracticeTypeToPlatform = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformsAssociatePracticeTypeToPlatform>>, TError,{platformId: string;data: AssociatePracticeTypeToPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof platformsAssociatePracticeTypeToPlatform>>,
        TError,
        {platformId: string;data: AssociatePracticeTypeToPlatformRequest},
        TContext
      > => {
      return useMutation(getPlatformsAssociatePracticeTypeToPlatformMutationOptions(options));
    }
    /**
 * @summary Returns billing information for the specified Platform.
 */
export const getBillingInfoForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<CompanyBillingInfo>(
      {url: `/api/v1/platforms/${platformId}/billing-info`, method: 'GET', signal
    },
      );
    }
  



export const getGetBillingInfoForPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/billing-info`
    ] as const;
    }

    
export const getGetBillingInfoForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInfoForPlatformQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInfoForPlatform>>> = ({ signal }) => getBillingInfoForPlatform(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInfoForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInfoForPlatform>>>
export type GetBillingInfoForPlatformQueryError = ErrorType<unknown>


/**
 * @summary Returns billing information for the specified Platform.
 */

export function useGetBillingInfoForPlatform<TData = Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInfoForPlatform>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBillingInfoForPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Returns PLG onboarding scheduling details for the specified Platform,
including the customer success meeting link, meeting datetime, and CEM information.
 */
export const getPlgOnboardingScheduling = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayPlgOnboardingSchedulingDetails>(
      {url: `/api/v1/platforms/${platformId}/plg-onboarding-scheduling`, method: 'GET', signal
    },
      );
    }
  



export const getGetPlgOnboardingSchedulingQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/plg-onboarding-scheduling`
    ] as const;
    }

    
export const getGetPlgOnboardingSchedulingQueryOptions = <TData = Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError = ErrorType<void>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlgOnboardingSchedulingQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>> = ({ signal }) => getPlgOnboardingScheduling(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlgOnboardingSchedulingQueryResult = NonNullable<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>>
export type GetPlgOnboardingSchedulingQueryError = ErrorType<void>


/**
 * @summary Returns PLG onboarding scheduling details for the specified Platform,
including the customer success meeting link, meeting datetime, and CEM information.
 */

export function useGetPlgOnboardingScheduling<TData = Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingScheduling>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlgOnboardingSchedulingQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Confirms a customer success meeting for a Platform after a Chilipiper booking.
 */
export const confirmCustomerSuccessMeeting = (
    platformId: string,
    associateCustomerSuccessMeetingDateTimeToPlatformRequest: AssociateCustomerSuccessMeetingDateTimeToPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-customer-success-meeting`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: associateCustomerSuccessMeetingDateTimeToPlatformRequest, signal
    },
      );
    }
  


export const getConfirmCustomerSuccessMeetingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCustomerSuccessMeeting>>, TError,{platformId: string;data: AssociateCustomerSuccessMeetingDateTimeToPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmCustomerSuccessMeeting>>, TError,{platformId: string;data: AssociateCustomerSuccessMeetingDateTimeToPlatformRequest}, TContext> => {

const mutationKey = ['confirmCustomerSuccessMeeting'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmCustomerSuccessMeeting>>, {platformId: string;data: AssociateCustomerSuccessMeetingDateTimeToPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  confirmCustomerSuccessMeeting(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmCustomerSuccessMeetingMutationResult = NonNullable<Awaited<ReturnType<typeof confirmCustomerSuccessMeeting>>>
    export type ConfirmCustomerSuccessMeetingMutationBody = AssociateCustomerSuccessMeetingDateTimeToPlatformRequest
    export type ConfirmCustomerSuccessMeetingMutationError = ErrorType<void>

    /**
 * @summary Confirms a customer success meeting for a Platform after a Chilipiper booking.
 */
export const useConfirmCustomerSuccessMeeting = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCustomerSuccessMeeting>>, TError,{platformId: string;data: AssociateCustomerSuccessMeetingDateTimeToPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmCustomerSuccessMeeting>>,
        TError,
        {platformId: string;data: AssociateCustomerSuccessMeetingDateTimeToPlatformRequest},
        TContext
      > => {
      return useMutation(getConfirmCustomerSuccessMeetingMutationOptions(options));
    }
    /**
 * @summary Returns platform product subscription record (projection customer history and billing lifecycle) for the specified platform.
Requires authentication — use `GET /product-subscriptions` on RepeatMD.AdminApp.Controllers.Api.PlatformsAllowAnonymousController for the anonymous operational list.
 */
export const getPlatformProductSubscriptionRecord = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayPlatformProductSubscriptions>(
      {url: `/api/v1/platforms/${platformId}/platform-product-subscription`, method: 'GET', signal
    },
      );
    }
  



export const getGetPlatformProductSubscriptionRecordQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/platform-product-subscription`
    ] as const;
    }

    
export const getGetPlatformProductSubscriptionRecordQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformProductSubscriptionRecordQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>> = ({ signal }) => getPlatformProductSubscriptionRecord(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformProductSubscriptionRecordQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>>
export type GetPlatformProductSubscriptionRecordQueryError = ErrorType<unknown>


/**
 * @summary Returns platform product subscription record (projection customer history and billing lifecycle) for the specified platform.
Requires authentication — use `GET /product-subscriptions` on RepeatMD.AdminApp.Controllers.Api.PlatformsAllowAnonymousController for the anonymous operational list.
 */

export function useGetPlatformProductSubscriptionRecord<TData = Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformProductSubscriptionRecord>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformProductSubscriptionRecordQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Initiates caller ID verification for a platform location's phone number.
 */
export const initiateCallerIdVerification = (
    platformId: string,
    locationId: string,
    initiateCallerIdVerificationForPlatformLocationRequest: InitiateCallerIdVerificationForPlatformLocationRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayCallerIdVerificationInitiationReference>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/caller-id-verification/initiate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: initiateCallerIdVerificationForPlatformLocationRequest, signal
    },
      );
    }
  


export const getInitiateCallerIdVerificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateCallerIdVerification>>, TError,{platformId: string;locationId: string;data: InitiateCallerIdVerificationForPlatformLocationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof initiateCallerIdVerification>>, TError,{platformId: string;locationId: string;data: InitiateCallerIdVerificationForPlatformLocationRequest}, TContext> => {

const mutationKey = ['initiateCallerIdVerification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiateCallerIdVerification>>, {platformId: string;locationId: string;data: InitiateCallerIdVerificationForPlatformLocationRequest}> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  initiateCallerIdVerification(platformId,locationId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type InitiateCallerIdVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof initiateCallerIdVerification>>>
    export type InitiateCallerIdVerificationMutationBody = InitiateCallerIdVerificationForPlatformLocationRequest
    export type InitiateCallerIdVerificationMutationError = ErrorType<unknown>

    /**
 * @summary Initiates caller ID verification for a platform location's phone number.
 */
export const useInitiateCallerIdVerification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateCallerIdVerification>>, TError,{platformId: string;locationId: string;data: InitiateCallerIdVerificationForPlatformLocationRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof initiateCallerIdVerification>>,
        TError,
        {platformId: string;locationId: string;data: InitiateCallerIdVerificationForPlatformLocationRequest},
        TContext
      > => {
      return useMutation(getInitiateCallerIdVerificationMutationOptions(options));
    }
    /**
 * @summary Retrieves the details of an initiated caller ID verification for a platform location.
 */
export const getCallerIdVerificationInitiationDetails = (
    platformId: string,
    callerIdVerificationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayCallerIdVerificationInitiatedForPlatformLocation>(
      {url: `/api/v1/platforms/${platformId}/caller-id-verification/${callerIdVerificationId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetCallerIdVerificationInitiationDetailsQueryKey = (platformId: string,
    callerIdVerificationId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/caller-id-verification/${callerIdVerificationId}`
    ] as const;
    }

    
export const getGetCallerIdVerificationInitiationDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError = ErrorType<unknown>>(platformId: string,
    callerIdVerificationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCallerIdVerificationInitiationDetailsQueryKey(platformId,callerIdVerificationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>> = ({ signal }) => getCallerIdVerificationInitiationDetails(platformId,callerIdVerificationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId && callerIdVerificationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCallerIdVerificationInitiationDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>>
export type GetCallerIdVerificationInitiationDetailsQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the details of an initiated caller ID verification for a platform location.
 */

export function useGetCallerIdVerificationInitiationDetails<TData = Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    callerIdVerificationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationInitiationDetails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCallerIdVerificationInitiationDetailsQueryOptions(platformId,callerIdVerificationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Confirms a pending caller ID verification for a platform location.
 */
export const confirmCallerIdVerification = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/caller-id-verification/confirm`, method: 'POST', signal
    },
      );
    }
  


export const getConfirmCallerIdVerificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCallerIdVerification>>, TError,{platformId: string;locationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmCallerIdVerification>>, TError,{platformId: string;locationId: string}, TContext> => {

const mutationKey = ['confirmCallerIdVerification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmCallerIdVerification>>, {platformId: string;locationId: string}> = (props) => {
          const {platformId,locationId} = props ?? {};

          return  confirmCallerIdVerification(platformId,locationId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmCallerIdVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof confirmCallerIdVerification>>>
    
    export type ConfirmCallerIdVerificationMutationError = ErrorType<unknown>

    /**
 * @summary Confirms a pending caller ID verification for a platform location.
 */
export const useConfirmCallerIdVerification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCallerIdVerification>>, TError,{platformId: string;locationId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmCallerIdVerification>>,
        TError,
        {platformId: string;locationId: string},
        TContext
      > => {
      return useMutation(getConfirmCallerIdVerificationMutationOptions(options));
    }
    /**
 * @summary Revokes the caller ID verification for a platform location.
 */
export const revokeCallerIdVerification = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/caller-id-verification`, method: 'DELETE', signal
    },
      );
    }
  


export const getRevokeCallerIdVerificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeCallerIdVerification>>, TError,{platformId: string;locationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeCallerIdVerification>>, TError,{platformId: string;locationId: string}, TContext> => {

const mutationKey = ['revokeCallerIdVerification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeCallerIdVerification>>, {platformId: string;locationId: string}> = (props) => {
          const {platformId,locationId} = props ?? {};

          return  revokeCallerIdVerification(platformId,locationId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeCallerIdVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof revokeCallerIdVerification>>>
    
    export type RevokeCallerIdVerificationMutationError = ErrorType<unknown>

    /**
 * @summary Revokes the caller ID verification for a platform location.
 */
export const useRevokeCallerIdVerification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeCallerIdVerification>>, TError,{platformId: string;locationId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeCallerIdVerification>>,
        TError,
        {platformId: string;locationId: string},
        TContext
      > => {
      return useMutation(getRevokeCallerIdVerificationMutationOptions(options));
    }
    /**
 * @summary Retrieves the caller ID verification status for a platform location.
 */
export const getCallerIdVerificationStatus = (
    platformId: string,
    locationId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayCallerIdVerificationStatusForPlatformLocation>(
      {url: `/api/v1/platforms/${platformId}/locations/${locationId}/caller-id-verification/status`, method: 'GET', signal
    },
      );
    }
  



export const getGetCallerIdVerificationStatusQueryKey = (platformId: string,
    locationId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/locations/${locationId}/caller-id-verification/status`
    ] as const;
    }

    
export const getGetCallerIdVerificationStatusQueryOptions = <TData = Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError = ErrorType<unknown>>(platformId: string,
    locationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCallerIdVerificationStatusQueryKey(platformId,locationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>> = ({ signal }) => getCallerIdVerificationStatus(platformId,locationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId && locationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCallerIdVerificationStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>>
export type GetCallerIdVerificationStatusQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the caller ID verification status for a platform location.
 */

export function useGetCallerIdVerificationStatus<TData = Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    locationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCallerIdVerificationStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCallerIdVerificationStatusQueryOptions(platformId,locationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieves the verified caller IDs for a platform.
 */
export const getVerifiedCallerIds = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayVerifiedCallerIdsForPlatform>(
      {url: `/api/v1/platforms/${platformId}/verified-caller-ids`, method: 'GET', signal
    },
      );
    }
  



export const getGetVerifiedCallerIdsQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/verified-caller-ids`
    ] as const;
    }

    
export const getGetVerifiedCallerIdsQueryOptions = <TData = Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerifiedCallerIdsQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerifiedCallerIds>>> = ({ signal }) => getVerifiedCallerIds(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVerifiedCallerIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getVerifiedCallerIds>>>
export type GetVerifiedCallerIdsQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the verified caller IDs for a platform.
 */

export function useGetVerifiedCallerIds<TData = Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVerifiedCallerIds>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVerifiedCallerIdsQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Switches a platform to a different Stripe region.
 */
export const _switch = (
    platformId: string,
    stripeRegion: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformSwitchedToStripeRegionEvent>(
      {url: `/api/v1/platforms/${platformId}/switch-stripe-region/${stripeRegion}`, method: 'POST', signal
    },
      );
    }
  


export const getSwitchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof _switch>>, TError,{platformId: string;stripeRegion: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof _switch>>, TError,{platformId: string;stripeRegion: string}, TContext> => {

const mutationKey = ['_switch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof _switch>>, {platformId: string;stripeRegion: string}> = (props) => {
          const {platformId,stripeRegion} = props ?? {};

          return  _switch(platformId,stripeRegion,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type _SwitchMutationResult = NonNullable<Awaited<ReturnType<typeof _switch>>>
    
    export type _SwitchMutationError = ErrorType<unknown>

    /**
 * @summary Switches a platform to a different Stripe region.
 */
export const useSwitch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof _switch>>, TError,{platformId: string;stripeRegion: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof _switch>>,
        TError,
        {platformId: string;stripeRegion: string},
        TContext
      > => {
      return useMutation(getSwitchMutationOptions(options));
    }
    /**
 * @summary Sets the data privacy region for a platform.
 */
export const setDataPrivacyRegionForPlatform = (
    platformId: string,
    setDataPrivacyRegionForPlatformRequest: SetDataPrivacyRegionForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/data-privacy-region`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setDataPrivacyRegionForPlatformRequest, signal
    },
      );
    }
  


export const getSetDataPrivacyRegionForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDataPrivacyRegionForPlatform>>, TError,{platformId: string;data: SetDataPrivacyRegionForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setDataPrivacyRegionForPlatform>>, TError,{platformId: string;data: SetDataPrivacyRegionForPlatformRequest}, TContext> => {

const mutationKey = ['setDataPrivacyRegionForPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDataPrivacyRegionForPlatform>>, {platformId: string;data: SetDataPrivacyRegionForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  setDataPrivacyRegionForPlatform(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetDataPrivacyRegionForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof setDataPrivacyRegionForPlatform>>>
    export type SetDataPrivacyRegionForPlatformMutationBody = SetDataPrivacyRegionForPlatformRequest
    export type SetDataPrivacyRegionForPlatformMutationError = ErrorType<unknown>

    /**
 * @summary Sets the data privacy region for a platform.
 */
export const useSetDataPrivacyRegionForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDataPrivacyRegionForPlatform>>, TError,{platformId: string;data: SetDataPrivacyRegionForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setDataPrivacyRegionForPlatform>>,
        TError,
        {platformId: string;data: SetDataPrivacyRegionForPlatformRequest},
        TContext
      > => {
      return useMutation(getSetDataPrivacyRegionForPlatformMutationOptions(options));
    }
    /**
 * @summary Enables gift cards for a platform.
 */
export const enableGiftCardsForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/enable-gift-cards`, method: 'PUT', signal
    },
      );
    }
  


export const getEnableGiftCardsForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableGiftCardsForPlatform>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableGiftCardsForPlatform>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['enableGiftCardsForPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableGiftCardsForPlatform>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  enableGiftCardsForPlatform(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type EnableGiftCardsForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof enableGiftCardsForPlatform>>>
    
    export type EnableGiftCardsForPlatformMutationError = ErrorType<unknown>

    /**
 * @summary Enables gift cards for a platform.
 */
export const useEnableGiftCardsForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableGiftCardsForPlatform>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof enableGiftCardsForPlatform>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getEnableGiftCardsForPlatformMutationOptions(options));
    }
    /**
 * @summary Disables gift cards for a platform.
 */
export const disableGiftCardsForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/disable-gift-cards`, method: 'PUT', signal
    },
      );
    }
  


export const getDisableGiftCardsForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableGiftCardsForPlatform>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableGiftCardsForPlatform>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['disableGiftCardsForPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableGiftCardsForPlatform>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  disableGiftCardsForPlatform(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DisableGiftCardsForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof disableGiftCardsForPlatform>>>
    
    export type DisableGiftCardsForPlatformMutationError = ErrorType<unknown>

    /**
 * @summary Disables gift cards for a platform.
 */
export const useDisableGiftCardsForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableGiftCardsForPlatform>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof disableGiftCardsForPlatform>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getDisableGiftCardsForPlatformMutationOptions(options));
    }
    /**
 * @summary Enables referral rewards for a platform.
 */
export const enableReferralRewardsForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/enable-referral-rewards`, method: 'PUT', signal
    },
      );
    }
  


export const getEnableReferralRewardsForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableReferralRewardsForPlatform>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableReferralRewardsForPlatform>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['enableReferralRewardsForPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableReferralRewardsForPlatform>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  enableReferralRewardsForPlatform(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type EnableReferralRewardsForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof enableReferralRewardsForPlatform>>>
    
    export type EnableReferralRewardsForPlatformMutationError = ErrorType<unknown>

    /**
 * @summary Enables referral rewards for a platform.
 */
export const useEnableReferralRewardsForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableReferralRewardsForPlatform>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof enableReferralRewardsForPlatform>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getEnableReferralRewardsForPlatformMutationOptions(options));
    }
    /**
 * @summary Disables referral rewards for a platform.
 */
export const disableReferralRewardsForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/disable-referral-rewards`, method: 'PUT', signal
    },
      );
    }
  


export const getDisableReferralRewardsForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableReferralRewardsForPlatform>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableReferralRewardsForPlatform>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['disableReferralRewardsForPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableReferralRewardsForPlatform>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  disableReferralRewardsForPlatform(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DisableReferralRewardsForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof disableReferralRewardsForPlatform>>>
    
    export type DisableReferralRewardsForPlatformMutationError = ErrorType<unknown>

    /**
 * @summary Disables referral rewards for a platform.
 */
export const useDisableReferralRewardsForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableReferralRewardsForPlatform>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof disableReferralRewardsForPlatform>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getDisableReferralRewardsForPlatformMutationOptions(options));
    }
    /**
 * @summary Schedule retail products to be visible on marketplace
 */
export const scheduleProductCatalogVisibilityOnMarketplace = (
    platformId: string,
    scheduleRetailProductsVisibilityOnMarketplaceRequest: ScheduleRetailProductsVisibilityOnMarketplaceRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/schedule-product-catalog-visible-on-marketplace`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: scheduleRetailProductsVisibilityOnMarketplaceRequest, signal
    },
      );
    }
  


export const getScheduleProductCatalogVisibilityOnMarketplaceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleProductCatalogVisibilityOnMarketplace>>, TError,{platformId: string;data: ScheduleRetailProductsVisibilityOnMarketplaceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scheduleProductCatalogVisibilityOnMarketplace>>, TError,{platformId: string;data: ScheduleRetailProductsVisibilityOnMarketplaceRequest}, TContext> => {

const mutationKey = ['scheduleProductCatalogVisibilityOnMarketplace'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleProductCatalogVisibilityOnMarketplace>>, {platformId: string;data: ScheduleRetailProductsVisibilityOnMarketplaceRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  scheduleProductCatalogVisibilityOnMarketplace(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ScheduleProductCatalogVisibilityOnMarketplaceMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleProductCatalogVisibilityOnMarketplace>>>
    export type ScheduleProductCatalogVisibilityOnMarketplaceMutationBody = ScheduleRetailProductsVisibilityOnMarketplaceRequest
    export type ScheduleProductCatalogVisibilityOnMarketplaceMutationError = ErrorType<unknown>

    /**
 * @summary Schedule retail products to be visible on marketplace
 */
export const useScheduleProductCatalogVisibilityOnMarketplace = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleProductCatalogVisibilityOnMarketplace>>, TError,{platformId: string;data: ScheduleRetailProductsVisibilityOnMarketplaceRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof scheduleProductCatalogVisibilityOnMarketplace>>,
        TError,
        {platformId: string;data: ScheduleRetailProductsVisibilityOnMarketplaceRequest},
        TContext
      > => {
      return useMutation(getScheduleProductCatalogVisibilityOnMarketplaceMutationOptions(options));
    }
    /**
 * @summary Schedule retail products to be visible on marketplace
 */
export const productCatalogMarketplaceVisibilitySchedule = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayRetailProductsMarketplaceVisibilitySchedule>(
      {url: `/api/v1/platforms/${platformId}/product-catalog-marketplace-visibility-schedule`, method: 'GET', signal
    },
      );
    }
  



export const getProductCatalogMarketplaceVisibilityScheduleQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/product-catalog-marketplace-visibility-schedule`
    ] as const;
    }

    
export const getProductCatalogMarketplaceVisibilityScheduleQueryOptions = <TData = Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductCatalogMarketplaceVisibilityScheduleQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>> = ({ signal }) => productCatalogMarketplaceVisibilitySchedule(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData> & { queryKey: QueryKey }
}

export type ProductCatalogMarketplaceVisibilityScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>>
export type ProductCatalogMarketplaceVisibilityScheduleQueryError = ErrorType<unknown>


/**
 * @summary Schedule retail products to be visible on marketplace
 */

export function useProductCatalogMarketplaceVisibilitySchedule<TData = Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof productCatalogMarketplaceVisibilitySchedule>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getProductCatalogMarketplaceVisibilityScheduleQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Hide retail products from the marketplace
 */
export const hideProductCatalogFromMarketplace = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/hide-product-catalog-from-marketplace`, method: 'PUT', signal
    },
      );
    }
  


export const getHideProductCatalogFromMarketplaceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideProductCatalogFromMarketplace>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hideProductCatalogFromMarketplace>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['hideProductCatalogFromMarketplace'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideProductCatalogFromMarketplace>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  hideProductCatalogFromMarketplace(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type HideProductCatalogFromMarketplaceMutationResult = NonNullable<Awaited<ReturnType<typeof hideProductCatalogFromMarketplace>>>
    
    export type HideProductCatalogFromMarketplaceMutationError = ErrorType<unknown>

    /**
 * @summary Hide retail products from the marketplace
 */
export const useHideProductCatalogFromMarketplace = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideProductCatalogFromMarketplace>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof hideProductCatalogFromMarketplace>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getHideProductCatalogFromMarketplaceMutationOptions(options));
    }
    /**
 * @summary Schedule SkinDrop to be visible on marketplace
 */
export const scheduleSkinDropVisibilityOnMarketplace = (
    platformId: string,
    scheduleSkinDropVisibilityOnMarketplaceRequest: ScheduleSkinDropVisibilityOnMarketplaceRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/schedule-skindrop-visible-on-marketplace`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: scheduleSkinDropVisibilityOnMarketplaceRequest, signal
    },
      );
    }
  


export const getScheduleSkinDropVisibilityOnMarketplaceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleSkinDropVisibilityOnMarketplace>>, TError,{platformId: string;data: ScheduleSkinDropVisibilityOnMarketplaceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scheduleSkinDropVisibilityOnMarketplace>>, TError,{platformId: string;data: ScheduleSkinDropVisibilityOnMarketplaceRequest}, TContext> => {

const mutationKey = ['scheduleSkinDropVisibilityOnMarketplace'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleSkinDropVisibilityOnMarketplace>>, {platformId: string;data: ScheduleSkinDropVisibilityOnMarketplaceRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  scheduleSkinDropVisibilityOnMarketplace(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ScheduleSkinDropVisibilityOnMarketplaceMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleSkinDropVisibilityOnMarketplace>>>
    export type ScheduleSkinDropVisibilityOnMarketplaceMutationBody = ScheduleSkinDropVisibilityOnMarketplaceRequest
    export type ScheduleSkinDropVisibilityOnMarketplaceMutationError = ErrorType<unknown>

    /**
 * @summary Schedule SkinDrop to be visible on marketplace
 */
export const useScheduleSkinDropVisibilityOnMarketplace = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleSkinDropVisibilityOnMarketplace>>, TError,{platformId: string;data: ScheduleSkinDropVisibilityOnMarketplaceRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof scheduleSkinDropVisibilityOnMarketplace>>,
        TError,
        {platformId: string;data: ScheduleSkinDropVisibilityOnMarketplaceRequest},
        TContext
      > => {
      return useMutation(getScheduleSkinDropVisibilityOnMarketplaceMutationOptions(options));
    }
    /**
 * @summary Get SkinDrop marketplace visibility schedule
 */
export const skinDropMarketplaceVisibilitySchedule = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplaySkinDropMarketplaceVisibilitySchedule>(
      {url: `/api/v1/platforms/${platformId}/skindrop-marketplace-visibility-schedule`, method: 'GET', signal
    },
      );
    }
  



export const getSkinDropMarketplaceVisibilityScheduleQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/skindrop-marketplace-visibility-schedule`
    ] as const;
    }

    
export const getSkinDropMarketplaceVisibilityScheduleQueryOptions = <TData = Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkinDropMarketplaceVisibilityScheduleQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>> = ({ signal }) => skinDropMarketplaceVisibilitySchedule(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData> & { queryKey: QueryKey }
}

export type SkinDropMarketplaceVisibilityScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>>
export type SkinDropMarketplaceVisibilityScheduleQueryError = ErrorType<unknown>


/**
 * @summary Get SkinDrop marketplace visibility schedule
 */

export function useSkinDropMarketplaceVisibilitySchedule<TData = Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof skinDropMarketplaceVisibilitySchedule>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSkinDropMarketplaceVisibilityScheduleQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Hide SkinDrop from the marketplace
 */
export const hideSkinDropFromMarketplace = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/hide-skindrop-from-marketplace`, method: 'PUT', signal
    },
      );
    }
  


export const getHideSkinDropFromMarketplaceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideSkinDropFromMarketplace>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hideSkinDropFromMarketplace>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['hideSkinDropFromMarketplace'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideSkinDropFromMarketplace>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  hideSkinDropFromMarketplace(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type HideSkinDropFromMarketplaceMutationResult = NonNullable<Awaited<ReturnType<typeof hideSkinDropFromMarketplace>>>
    
    export type HideSkinDropFromMarketplaceMutationError = ErrorType<unknown>

    /**
 * @summary Hide SkinDrop from the marketplace
 */
export const useHideSkinDropFromMarketplace = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideSkinDropFromMarketplace>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof hideSkinDropFromMarketplace>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getHideSkinDropFromMarketplaceMutationOptions(options));
    }
    /**
 * @summary Retrieves all repeat cash transactions for a specific platform
 */
export const getRepeatCashTransactionsForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayRepeatCashTransactionsForPlatform>(
      {url: `/api/v1/platforms/${platformId}/repeat-cash-transactions`, method: 'GET', signal
    },
      );
    }
  



export const getGetRepeatCashTransactionsForPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/repeat-cash-transactions`
    ] as const;
    }

    
export const getGetRepeatCashTransactionsForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRepeatCashTransactionsForPlatformQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>> = ({ signal }) => getRepeatCashTransactionsForPlatform(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRepeatCashTransactionsForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>>
export type GetRepeatCashTransactionsForPlatformQueryError = ErrorType<unknown>


/**
 * @summary Retrieves all repeat cash transactions for a specific platform
 */

export function useGetRepeatCashTransactionsForPlatform<TData = Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRepeatCashTransactionsForPlatform>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRepeatCashTransactionsForPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieves all disputes for a specific platform
 */
export const getDisputesForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayDisputesForPlatform>(
      {url: `/api/v1/platforms/${platformId}/disputes`, method: 'GET', signal
    },
      );
    }
  



export const getGetDisputesForPlatformQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/disputes`
    ] as const;
    }

    
export const getGetDisputesForPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getDisputesForPlatform>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDisputesForPlatformQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDisputesForPlatform>>> = ({ signal }) => getDisputesForPlatform(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDisputesForPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getDisputesForPlatform>>>
export type GetDisputesForPlatformQueryError = ErrorType<unknown>


/**
 * @summary Retrieves all disputes for a specific platform
 */

export function useGetDisputesForPlatform<TData = Awaited<ReturnType<typeof getDisputesForPlatform>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDisputesForPlatform>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDisputesForPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieves the dispute details
 */
export const getDisputeDetails = (
    platformId: string,
    disputeId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayDisputeDetails>(
      {url: `/api/v1/platforms/${platformId}/dispute/${disputeId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetDisputeDetailsQueryKey = (platformId: string,
    disputeId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/dispute/${disputeId}`
    ] as const;
    }

    
export const getGetDisputeDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getDisputeDetails>>, TError = ErrorType<unknown>>(platformId: string,
    disputeId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDisputeDetailsQueryKey(platformId,disputeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDisputeDetails>>> = ({ signal }) => getDisputeDetails(platformId,disputeId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId && disputeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDisputeDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getDisputeDetails>>>
export type GetDisputeDetailsQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the dispute details
 */

export function useGetDisputeDetails<TData = Awaited<ReturnType<typeof getDisputeDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    disputeId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDisputeDetails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDisputeDetailsQueryOptions(platformId,disputeId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Enables automatic payment enforcement for a platform.
 */
export const enableAutomaticPaymentEnforcementForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/enable-automatic-payment-enforcement`, method: 'PUT', signal
    },
      );
    }
  


export const getEnableAutomaticPaymentEnforcementForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAutomaticPaymentEnforcementForPlatform>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAutomaticPaymentEnforcementForPlatform>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['enableAutomaticPaymentEnforcementForPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAutomaticPaymentEnforcementForPlatform>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  enableAutomaticPaymentEnforcementForPlatform(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type EnableAutomaticPaymentEnforcementForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof enableAutomaticPaymentEnforcementForPlatform>>>
    
    export type EnableAutomaticPaymentEnforcementForPlatformMutationError = ErrorType<unknown>

    /**
 * @summary Enables automatic payment enforcement for a platform.
 */
export const useEnableAutomaticPaymentEnforcementForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAutomaticPaymentEnforcementForPlatform>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof enableAutomaticPaymentEnforcementForPlatform>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getEnableAutomaticPaymentEnforcementForPlatformMutationOptions(options));
    }
    /**
 * @summary Disables automatic payment enforcement for a platform.
 */
export const disableAutomaticPaymentEnforcementForPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/disable-automatic-payment-enforcement`, method: 'PUT', signal
    },
      );
    }
  


export const getDisableAutomaticPaymentEnforcementForPlatformMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAutomaticPaymentEnforcementForPlatform>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableAutomaticPaymentEnforcementForPlatform>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['disableAutomaticPaymentEnforcementForPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableAutomaticPaymentEnforcementForPlatform>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  disableAutomaticPaymentEnforcementForPlatform(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DisableAutomaticPaymentEnforcementForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof disableAutomaticPaymentEnforcementForPlatform>>>
    
    export type DisableAutomaticPaymentEnforcementForPlatformMutationError = ErrorType<unknown>

    /**
 * @summary Disables automatic payment enforcement for a platform.
 */
export const useDisableAutomaticPaymentEnforcementForPlatform = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAutomaticPaymentEnforcementForPlatform>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof disableAutomaticPaymentEnforcementForPlatform>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getDisableAutomaticPaymentEnforcementForPlatformMutationOptions(options));
    }
    /**
 * @summary Retrieves whether automatic payment enforcement is enabled for a platform.
 */
export const getAutomaticPaymentEnforcementStatus = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<boolean>(
      {url: `/api/v1/platforms/${platformId}/automatic-payment-enforcement-status`, method: 'GET', signal
    },
      );
    }
  



export const getGetAutomaticPaymentEnforcementStatusQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/automatic-payment-enforcement-status`
    ] as const;
    }

    
export const getGetAutomaticPaymentEnforcementStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAutomaticPaymentEnforcementStatusQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>> = ({ signal }) => getAutomaticPaymentEnforcementStatus(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAutomaticPaymentEnforcementStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>>
export type GetAutomaticPaymentEnforcementStatusQueryError = ErrorType<unknown>


/**
 * @summary Retrieves whether automatic payment enforcement is enabled for a platform.
 */

export function useGetAutomaticPaymentEnforcementStatus<TData = Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAutomaticPaymentEnforcementStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAutomaticPaymentEnforcementStatusQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Initiates a practice catalog data import for a platform.
 */
export const initiatePracticeCatalogDataImport = (
    platformId: string,
    initiatePracticeCatalogDataImportBody: InitiatePracticeCatalogDataImportBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(initiatePracticeCatalogDataImportBody.jsonPayload !== undefined) {
 formData.append(`jsonPayload`, initiatePracticeCatalogDataImportBody.jsonPayload);
 }
if(initiatePracticeCatalogDataImportBody.files !== undefined) {
 initiatePracticeCatalogDataImportBody.files.forEach(value => formData.append(`files`, value));
 }

      return customAxios<string>(
      {url: `/api/v1/platforms/${platformId}/catalog/import`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getInitiatePracticeCatalogDataImportMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiatePracticeCatalogDataImport>>, TError,{platformId: string;data: InitiatePracticeCatalogDataImportBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof initiatePracticeCatalogDataImport>>, TError,{platformId: string;data: InitiatePracticeCatalogDataImportBody}, TContext> => {

const mutationKey = ['initiatePracticeCatalogDataImport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiatePracticeCatalogDataImport>>, {platformId: string;data: InitiatePracticeCatalogDataImportBody}> = (props) => {
          const {platformId,data} = props ?? {};

          return  initiatePracticeCatalogDataImport(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type InitiatePracticeCatalogDataImportMutationResult = NonNullable<Awaited<ReturnType<typeof initiatePracticeCatalogDataImport>>>
    export type InitiatePracticeCatalogDataImportMutationBody = InitiatePracticeCatalogDataImportBody
    export type InitiatePracticeCatalogDataImportMutationError = ErrorType<void>

    /**
 * @summary Initiates a practice catalog data import for a platform.
 */
export const useInitiatePracticeCatalogDataImport = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiatePracticeCatalogDataImport>>, TError,{platformId: string;data: InitiatePracticeCatalogDataImportBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof initiatePracticeCatalogDataImport>>,
        TError,
        {platformId: string;data: InitiatePracticeCatalogDataImportBody},
        TContext
      > => {
      return useMutation(getInitiatePracticeCatalogDataImportMutationOptions(options));
    }
    /**
 * @summary Creates a single draft treatment from structured "basics" (name, description, price, quantity, and an
optional image) by running them through the catalog importer's AI enrichment pipeline (concern/area
tagging, media-library image matching, unit-type resolution). Intended for agent-driven flows (Fin).
Returns immediately with the import id; the enriched draft is created asynchronously. When a callback
URL and conversation id are supplied, the backend POSTs a completion notification to that URL so a
paused Fin "Wait for webhook" workflow can resume.
 */
export const createTreatmentFromCatalog = (
    platformId: string,
    createTreatmentFromCatalogRequest: CreateTreatmentFromCatalogRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<string>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/treatment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTreatmentFromCatalogRequest, signal
    },
      );
    }
  


export const getCreateTreatmentFromCatalogMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTreatmentFromCatalog>>, TError,{platformId: string;data: CreateTreatmentFromCatalogRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTreatmentFromCatalog>>, TError,{platformId: string;data: CreateTreatmentFromCatalogRequest}, TContext> => {

const mutationKey = ['createTreatmentFromCatalog'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTreatmentFromCatalog>>, {platformId: string;data: CreateTreatmentFromCatalogRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  createTreatmentFromCatalog(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTreatmentFromCatalogMutationResult = NonNullable<Awaited<ReturnType<typeof createTreatmentFromCatalog>>>
    export type CreateTreatmentFromCatalogMutationBody = CreateTreatmentFromCatalogRequest
    export type CreateTreatmentFromCatalogMutationError = ErrorType<unknown>

    /**
 * @summary Creates a single draft treatment from structured "basics" (name, description, price, quantity, and an
optional image) by running them through the catalog importer's AI enrichment pipeline (concern/area
tagging, media-library image matching, unit-type resolution). Intended for agent-driven flows (Fin).
Returns immediately with the import id; the enriched draft is created asynchronously. When a callback
URL and conversation id are supplied, the backend POSTs a completion notification to that URL so a
paused Fin "Wait for webhook" workflow can resume.
 */
export const useCreateTreatmentFromCatalog = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTreatmentFromCatalog>>, TError,{platformId: string;data: CreateTreatmentFromCatalogRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTreatmentFromCatalog>>,
        TError,
        {platformId: string;data: CreateTreatmentFromCatalogRequest},
        TContext
      > => {
      return useMutation(getCreateTreatmentFromCatalogMutationOptions(options));
    }
    /**
 * @summary Creates a single draft package from structured "basics" (name, price, an optional description/image, and
the included treatments — each a name + quantity) by running them through the catalog importer's AI
enrichment pipeline (concern/area tagging, media-library image matching, unit-type resolution). Intended
for agent-driven flows (Fin). The included treatments are created as inline package-scoped products.
A package requires at least two different included treatments (the catalog AI demotes single-treatment
bundles to treatment pricing). Returns immediately with the import id; the enriched draft is created
asynchronously. When a callback URL and conversation id are supplied, the backend POSTs a completion
notification to that URL so a paused Fin "Wait for webhook" workflow can resume.
 */
export const createPackageFromCatalog = (
    platformId: string,
    createPackageFromCatalogRequest: CreatePackageFromCatalogRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayInitiatedPackageCatalogImportResponse>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/package`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPackageFromCatalogRequest, signal
    },
      );
    }
  


export const getCreatePackageFromCatalogMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPackageFromCatalog>>, TError,{platformId: string;data: CreatePackageFromCatalogRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPackageFromCatalog>>, TError,{platformId: string;data: CreatePackageFromCatalogRequest}, TContext> => {

const mutationKey = ['createPackageFromCatalog'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPackageFromCatalog>>, {platformId: string;data: CreatePackageFromCatalogRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  createPackageFromCatalog(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePackageFromCatalogMutationResult = NonNullable<Awaited<ReturnType<typeof createPackageFromCatalog>>>
    export type CreatePackageFromCatalogMutationBody = CreatePackageFromCatalogRequest
    export type CreatePackageFromCatalogMutationError = ErrorType<unknown>

    /**
 * @summary Creates a single draft package from structured "basics" (name, price, an optional description/image, and
the included treatments — each a name + quantity) by running them through the catalog importer's AI
enrichment pipeline (concern/area tagging, media-library image matching, unit-type resolution). Intended
for agent-driven flows (Fin). The included treatments are created as inline package-scoped products.
A package requires at least two different included treatments (the catalog AI demotes single-treatment
bundles to treatment pricing). Returns immediately with the import id; the enriched draft is created
asynchronously. When a callback URL and conversation id are supplied, the backend POSTs a completion
notification to that URL so a paused Fin "Wait for webhook" workflow can resume.
 */
export const useCreatePackageFromCatalog = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPackageFromCatalog>>, TError,{platformId: string;data: CreatePackageFromCatalogRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPackageFromCatalog>>,
        TError,
        {platformId: string;data: CreatePackageFromCatalogRequest},
        TContext
      > => {
      return useMutation(getCreatePackageFromCatalogMutationOptions(options));
    }
    /**
 * @summary Creates a single draft membership from structured "basics" (name, monthly price, and optional
commitment, included services, discounts, and description) by running them through the catalog
importer's AI enrichment pipeline plus a chained generation step that resolves the included services
and discounts by name against the platform's active catalog. Intended for agent-driven flows (Fin).
Only name and monthly price are required. Returns immediately with the import id; the enriched draft
is created asynchronously. When a callback URL and conversation id are supplied, the backend POSTs a
completion notification to that URL so a paused Fin "Wait for webhook" workflow can resume.
 */
export const createMembershipFromCatalog = (
    platformId: string,
    createMembershipFromCatalogRequest: CreateMembershipFromCatalogRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayInitiatedMembershipCatalogImportResponse>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/membership`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMembershipFromCatalogRequest, signal
    },
      );
    }
  


export const getCreateMembershipFromCatalogMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMembershipFromCatalog>>, TError,{platformId: string;data: CreateMembershipFromCatalogRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMembershipFromCatalog>>, TError,{platformId: string;data: CreateMembershipFromCatalogRequest}, TContext> => {

const mutationKey = ['createMembershipFromCatalog'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMembershipFromCatalog>>, {platformId: string;data: CreateMembershipFromCatalogRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  createMembershipFromCatalog(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMembershipFromCatalogMutationResult = NonNullable<Awaited<ReturnType<typeof createMembershipFromCatalog>>>
    export type CreateMembershipFromCatalogMutationBody = CreateMembershipFromCatalogRequest
    export type CreateMembershipFromCatalogMutationError = ErrorType<unknown>

    /**
 * @summary Creates a single draft membership from structured "basics" (name, monthly price, and optional
commitment, included services, discounts, and description) by running them through the catalog
importer's AI enrichment pipeline plus a chained generation step that resolves the included services
and discounts by name against the platform's active catalog. Intended for agent-driven flows (Fin).
Only name and monthly price are required. Returns immediately with the import id; the enriched draft
is created asynchronously. When a callback URL and conversation id are supplied, the backend POSTs a
completion notification to that URL so a paused Fin "Wait for webhook" workflow can resume.
 */
export const useCreateMembershipFromCatalog = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMembershipFromCatalog>>, TError,{platformId: string;data: CreateMembershipFromCatalogRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMembershipFromCatalog>>,
        TError,
        {platformId: string;data: CreateMembershipFromCatalogRequest},
        TContext
      > => {
      return useMutation(getCreateMembershipFromCatalogMutationOptions(options));
    }
    /**
 * @summary Retrieves the status of a practice catalog data import.
 */
export const getPracticeCatalogDataImportStatus = (
    platformId: string,
    importId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PracticeCatalogDataImportStatus>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/${importId}/status`, method: 'GET', signal
    },
      );
    }
  



export const getGetPracticeCatalogDataImportStatusQueryKey = (platformId: string,
    importId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/catalog/import/${importId}/status`
    ] as const;
    }

    
export const getGetPracticeCatalogDataImportStatusQueryOptions = <TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError = ErrorType<unknown>>(platformId: string,
    importId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPracticeCatalogDataImportStatusQueryKey(platformId,importId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>> = ({ signal }) => getPracticeCatalogDataImportStatus(platformId,importId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId && importId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPracticeCatalogDataImportStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>>
export type GetPracticeCatalogDataImportStatusQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the status of a practice catalog data import.
 */

export function useGetPracticeCatalogDataImportStatus<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPracticeCatalogDataImportStatusQueryOptions(platformId,importId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieves the latest practice catalog data import for a platform.
Returns import id, status, and timestamps; all properties are null when no import exists.
 */
export const getLatestPracticeCatalogDataImport = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<LatestPracticeCatalogDataImportRetrievedResponse>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/latest`, method: 'GET', signal
    },
      );
    }
  



export const getGetLatestPracticeCatalogDataImportQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/catalog/import/latest`
    ] as const;
    }

    
export const getGetLatestPracticeCatalogDataImportQueryOptions = <TData = Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestPracticeCatalogDataImportQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>> = ({ signal }) => getLatestPracticeCatalogDataImport(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLatestPracticeCatalogDataImportQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>>
export type GetLatestPracticeCatalogDataImportQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the latest practice catalog data import for a platform.
Returns import id, status, and timestamps; all properties are null when no import exists.
 */

export function useGetLatestPracticeCatalogDataImport<TData = Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLatestPracticeCatalogDataImport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLatestPracticeCatalogDataImportQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieves the preview of a practice catalog data import.
Returns null if the import was not started or is already completed.
 */
export const getPracticeCatalogDataImportPreview = (
    platformId: string,
    importId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PracticeCatalogDataImportPreview>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/${importId}/preview`, method: 'GET', signal
    },
      );
    }
  



export const getGetPracticeCatalogDataImportPreviewQueryKey = (platformId: string,
    importId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/catalog/import/${importId}/preview`
    ] as const;
    }

    
export const getGetPracticeCatalogDataImportPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError = ErrorType<unknown>>(platformId: string,
    importId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPracticeCatalogDataImportPreviewQueryKey(platformId,importId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>> = ({ signal }) => getPracticeCatalogDataImportPreview(platformId,importId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId && importId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPracticeCatalogDataImportPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>>
export type GetPracticeCatalogDataImportPreviewQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the preview of a practice catalog data import.
Returns null if the import was not started or is already completed.
 */

export function useGetPracticeCatalogDataImportPreview<TData = Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError = ErrorType<unknown>>(
 platformId: string,
    importId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPracticeCatalogDataImportPreview>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPracticeCatalogDataImportPreviewQueryOptions(platformId,importId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Completes a practice catalog data import and cleans up temporary files.
 */
export const completePracticeCatalogDataImport = (
    platformId: string,
    importId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/${importId}/complete`, method: 'POST', signal
    },
      );
    }
  


export const getCompletePracticeCatalogDataImportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePracticeCatalogDataImport>>, TError,{platformId: string;importId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completePracticeCatalogDataImport>>, TError,{platformId: string;importId: string}, TContext> => {

const mutationKey = ['completePracticeCatalogDataImport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completePracticeCatalogDataImport>>, {platformId: string;importId: string}> = (props) => {
          const {platformId,importId} = props ?? {};

          return  completePracticeCatalogDataImport(platformId,importId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CompletePracticeCatalogDataImportMutationResult = NonNullable<Awaited<ReturnType<typeof completePracticeCatalogDataImport>>>
    
    export type CompletePracticeCatalogDataImportMutationError = ErrorType<unknown>

    /**
 * @summary Completes a practice catalog data import and cleans up temporary files.
 */
export const useCompletePracticeCatalogDataImport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePracticeCatalogDataImport>>, TError,{platformId: string;importId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof completePracticeCatalogDataImport>>,
        TError,
        {platformId: string;importId: string},
        TContext
      > => {
      return useMutation(getCompletePracticeCatalogDataImportMutationOptions(options));
    }
    /**
 * @summary Records that the user has been notified that this catalog import has finished
(e.g. dismissed the notification or opened the services page). Idempotent.
 */
export const acknowledgePracticeCatalogDataImport = (
    platformId: string,
    importId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/catalog/import/${importId}/acknowledge`, method: 'POST', signal
    },
      );
    }
  


export const getAcknowledgePracticeCatalogDataImportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgePracticeCatalogDataImport>>, TError,{platformId: string;importId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acknowledgePracticeCatalogDataImport>>, TError,{platformId: string;importId: string}, TContext> => {

const mutationKey = ['acknowledgePracticeCatalogDataImport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acknowledgePracticeCatalogDataImport>>, {platformId: string;importId: string}> = (props) => {
          const {platformId,importId} = props ?? {};

          return  acknowledgePracticeCatalogDataImport(platformId,importId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type AcknowledgePracticeCatalogDataImportMutationResult = NonNullable<Awaited<ReturnType<typeof acknowledgePracticeCatalogDataImport>>>
    
    export type AcknowledgePracticeCatalogDataImportMutationError = ErrorType<unknown>

    /**
 * @summary Records that the user has been notified that this catalog import has finished
(e.g. dismissed the notification or opened the services page). Idempotent.
 */
export const useAcknowledgePracticeCatalogDataImport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgePracticeCatalogDataImport>>, TError,{platformId: string;importId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof acknowledgePracticeCatalogDataImport>>,
        TError,
        {platformId: string;importId: string},
        TContext
      > => {
      return useMutation(getAcknowledgePracticeCatalogDataImportMutationOptions(options));
    }
    /**
 * @summary Retrieves the company verification process (KYB) status for a platform.
 */
export const getCompanyVerificationProcess = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayCompanyVerificationProcess>(
      {url: `/api/v1/platforms/${platformId}/verification-process`, method: 'GET', signal
    },
      );
    }
  



export const getGetCompanyVerificationProcessQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/verification-process`
    ] as const;
    }

    
export const getGetCompanyVerificationProcessQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyVerificationProcessQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyVerificationProcess>>> = ({ signal }) => getCompanyVerificationProcess(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyVerificationProcessQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyVerificationProcess>>>
export type GetCompanyVerificationProcessQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the company verification process (KYB) status for a platform.
 */

export function useGetCompanyVerificationProcess<TData = Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationProcess>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCompanyVerificationProcessQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieves a paged list of all platforms with each platform's company KYB verification
status (null when the platform has never started verification), together with the actor who
last set that status and when, for the global admin business-verification view.
 */
export const getPagedPlatformVerificationProcesses = (
    params?: GetPagedPlatformVerificationProcessesParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayPagedPlatformVerificationProcessesResponse>(
      {url: `/api/v1/platforms/verification-processes/paged`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetPagedPlatformVerificationProcessesQueryKey = (params?: GetPagedPlatformVerificationProcessesParams,) => {
    return [
    `/api/v1/platforms/verification-processes/paged`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetPagedPlatformVerificationProcessesQueryOptions = <TData = Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError = ErrorType<unknown>>(params?: GetPagedPlatformVerificationProcessesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPagedPlatformVerificationProcessesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>> = ({ signal }) => getPagedPlatformVerificationProcesses(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPagedPlatformVerificationProcessesQueryResult = NonNullable<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>>
export type GetPagedPlatformVerificationProcessesQueryError = ErrorType<unknown>


/**
 * @summary Retrieves a paged list of all platforms with each platform's company KYB verification
status (null when the platform has never started verification), together with the actor who
last set that status and when, for the global admin business-verification view.
 */

export function useGetPagedPlatformVerificationProcesses<TData = Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError = ErrorType<unknown>>(
 params?: GetPagedPlatformVerificationProcessesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPagedPlatformVerificationProcesses>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPagedPlatformVerificationProcessesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieves company verification information for a platform.
 */
export const getCompanyVerificationInformation = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayCompanyVerificationInformation>(
      {url: `/api/v1/platforms/${platformId}/verification-information`, method: 'GET', signal
    },
      );
    }
  



export const getGetCompanyVerificationInformationQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/verification-information`
    ] as const;
    }

    
export const getGetCompanyVerificationInformationQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyVerificationInformationQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyVerificationInformation>>> = ({ signal }) => getCompanyVerificationInformation(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyVerificationInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyVerificationInformation>>>
export type GetCompanyVerificationInformationQueryError = ErrorType<unknown>


/**
 * @summary Retrieves company verification information for a platform.
 */

export function useGetCompanyVerificationInformation<TData = Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyVerificationInformation>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCompanyVerificationInformationQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Retrieves Persona company KYB account data for a platform.
 */
export const getCompanyKybAccounts = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayCompanyKybAccountsResponse>(
      {url: `/api/v1/platforms/${platformId}/verification-accounts`, method: 'GET', signal
    },
      );
    }
  



export const getGetCompanyKybAccountsQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/verification-accounts`
    ] as const;
    }

    
export const getGetCompanyKybAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyKybAccountsQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyKybAccounts>>> = ({ signal }) => getCompanyKybAccounts(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyKybAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyKybAccounts>>>
export type GetCompanyKybAccountsQueryError = ErrorType<unknown>


/**
 * @summary Retrieves Persona company KYB account data for a platform.
 */

export function useGetCompanyKybAccounts<TData = Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyKybAccounts>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCompanyKybAccountsQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Re-tracks the `PersonaKybInquiryCompleted` Customer.io event for every active platform
admin with the Administrator role — the manual compensation entry point when the
webhook-driven `inquiry.completed` notification was missed or failed. There is no
dedup: every call emits a fresh track event per admin, so only run it when the
notification genuinely needs re-sending.
 */
export const notifyPlatformAdminsOfPersonaKybInquiryCompleted = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/verification-process/completed-notifications`, method: 'POST', signal
    },
      );
    }
  


export const getNotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyPlatformAdminsOfPersonaKybInquiryCompleted>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notifyPlatformAdminsOfPersonaKybInquiryCompleted>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['notifyPlatformAdminsOfPersonaKybInquiryCompleted'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notifyPlatformAdminsOfPersonaKybInquiryCompleted>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  notifyPlatformAdminsOfPersonaKybInquiryCompleted(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type NotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationResult = NonNullable<Awaited<ReturnType<typeof notifyPlatformAdminsOfPersonaKybInquiryCompleted>>>
    
    export type NotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationError = ErrorType<unknown>

    /**
 * @summary Re-tracks the `PersonaKybInquiryCompleted` Customer.io event for every active platform
admin with the Administrator role — the manual compensation entry point when the
webhook-driven `inquiry.completed` notification was missed or failed. There is no
dedup: every call emits a fresh track event per admin, so only run it when the
notification genuinely needs re-sending.
 */
export const useNotifyPlatformAdminsOfPersonaKybInquiryCompleted = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyPlatformAdminsOfPersonaKybInquiryCompleted>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof notifyPlatformAdminsOfPersonaKybInquiryCompleted>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getNotifyPlatformAdminsOfPersonaKybInquiryCompletedMutationOptions(options));
    }
    /**
 * @summary Manually sets a platform's Company KYB verification status — the compensation entry point
for correcting a status stomped by an infrastructure bug (e.g. a stale webhook demoting an
Approved process). Unlike webhook-driven changes, this manual path bypasses the domain
transition guard, so it can demote an Approved process (forced de-approval). Setting the
same status remains a no-op.
 */
export const setCompanyKybVerificationStatusForPlatform = (
    platformId: string,
    setCompanyKybVerificationStatusForPlatformRequest: SetCompanyKybVerificationStatusForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayCompanyKybVerificationStatusForPlatform>(
      {url: `/api/v1/platforms/${platformId}/verification-process/status`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setCompanyKybVerificationStatusForPlatformRequest, signal
    },
      );
    }
  


export const getSetCompanyKybVerificationStatusForPlatformMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCompanyKybVerificationStatusForPlatform>>, TError,{platformId: string;data: SetCompanyKybVerificationStatusForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setCompanyKybVerificationStatusForPlatform>>, TError,{platformId: string;data: SetCompanyKybVerificationStatusForPlatformRequest}, TContext> => {

const mutationKey = ['setCompanyKybVerificationStatusForPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCompanyKybVerificationStatusForPlatform>>, {platformId: string;data: SetCompanyKybVerificationStatusForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  setCompanyKybVerificationStatusForPlatform(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SetCompanyKybVerificationStatusForPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof setCompanyKybVerificationStatusForPlatform>>>
    export type SetCompanyKybVerificationStatusForPlatformMutationBody = SetCompanyKybVerificationStatusForPlatformRequest
    export type SetCompanyKybVerificationStatusForPlatformMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Manually sets a platform's Company KYB verification status — the compensation entry point
for correcting a status stomped by an infrastructure bug (e.g. a stale webhook demoting an
Approved process). Unlike webhook-driven changes, this manual path bypasses the domain
transition guard, so it can demote an Approved process (forced de-approval). Setting the
same status remains a no-op.
 */
export const useSetCompanyKybVerificationStatusForPlatform = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCompanyKybVerificationStatusForPlatform>>, TError,{platformId: string;data: SetCompanyKybVerificationStatusForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setCompanyKybVerificationStatusForPlatform>>,
        TError,
        {platformId: string;data: SetCompanyKybVerificationStatusForPlatformRequest},
        TContext
      > => {
      return useMutation(getSetCompanyKybVerificationStatusForPlatformMutationOptions(options));
    }
    /**
 * @summary Retrieves onboarding progress for a platform.
Returns a not-started response when the platform exists but no onboarding progress has been recorded yet.
 */
export const getPlatformOnboardingProgress = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayPlatformOnboardingProgress>(
      {url: `/api/v1/platforms/${platformId}/onboarding-progress`, method: 'GET', signal
    },
      );
    }
  



export const getGetPlatformOnboardingProgressQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/onboarding-progress`
    ] as const;
    }

    
export const getGetPlatformOnboardingProgressQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError = ErrorType<void>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformOnboardingProgressQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>> = ({ signal }) => getPlatformOnboardingProgress(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformOnboardingProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>>
export type GetPlatformOnboardingProgressQueryError = ErrorType<void>


/**
 * @summary Retrieves onboarding progress for a platform.
Returns a not-started response when the platform exists but no onboarding progress has been recorded yet.
 */

export function useGetPlatformOnboardingProgress<TData = Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError = ErrorType<void>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformOnboardingProgress>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformOnboardingProgressQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Confirms onboarding user information for a platform.
Captures the currently confirmed user details even when no admin user fields changed.
 */
export const confirmOnboardingUserInformation = (
    platformId: string,
    confirmOnboardingUserInformationForPlatformRequest: ConfirmOnboardingUserInformationForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-onboarding-user-information`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmOnboardingUserInformationForPlatformRequest, signal
    },
      );
    }
  


export const getConfirmOnboardingUserInformationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingUserInformation>>, TError,{platformId: string;data: ConfirmOnboardingUserInformationForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingUserInformation>>, TError,{platformId: string;data: ConfirmOnboardingUserInformationForPlatformRequest}, TContext> => {

const mutationKey = ['confirmOnboardingUserInformation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOnboardingUserInformation>>, {platformId: string;data: ConfirmOnboardingUserInformationForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  confirmOnboardingUserInformation(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOnboardingUserInformationMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOnboardingUserInformation>>>
    export type ConfirmOnboardingUserInformationMutationBody = ConfirmOnboardingUserInformationForPlatformRequest
    export type ConfirmOnboardingUserInformationMutationError = ErrorType<unknown>

    /**
 * @summary Confirms onboarding user information for a platform.
Captures the currently confirmed user details even when no admin user fields changed.
 */
export const useConfirmOnboardingUserInformation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingUserInformation>>, TError,{platformId: string;data: ConfirmOnboardingUserInformationForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmOnboardingUserInformation>>,
        TError,
        {platformId: string;data: ConfirmOnboardingUserInformationForPlatformRequest},
        TContext
      > => {
      return useMutation(getConfirmOnboardingUserInformationMutationOptions(options));
    }
    /**
 * @summary Confirms onboarding locations for a platform.
Captures the current state of all platform locations as confirmed during onboarding.
 */
export const confirmOnboardingLocations = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-onboarding-locations`, method: 'POST', signal
    },
      );
    }
  


export const getConfirmOnboardingLocationsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingLocations>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingLocations>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['confirmOnboardingLocations'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOnboardingLocations>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  confirmOnboardingLocations(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOnboardingLocationsMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOnboardingLocations>>>
    
    export type ConfirmOnboardingLocationsMutationError = ErrorType<void>

    /**
 * @summary Confirms onboarding locations for a platform.
Captures the current state of all platform locations as confirmed during onboarding.
 */
export const useConfirmOnboardingLocations = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingLocations>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmOnboardingLocations>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getConfirmOnboardingLocationsMutationOptions(options));
    }
    /**
 * @summary Completes the product-led growth onboarding flow for a platform.
 */
export const completePlgOnboarding = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/complete-plg-onboarding`, method: 'POST', signal
    },
      );
    }
  


export const getCompletePlgOnboardingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePlgOnboarding>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completePlgOnboarding>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['completePlgOnboarding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completePlgOnboarding>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  completePlgOnboarding(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CompletePlgOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof completePlgOnboarding>>>
    
    export type CompletePlgOnboardingMutationError = ErrorType<unknown>

    /**
 * @summary Completes the product-led growth onboarding flow for a platform.
 */
export const useCompletePlgOnboarding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePlgOnboarding>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof completePlgOnboarding>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getCompletePlgOnboardingMutationOptions(options));
    }
    /**
 * @summary Confirms the onboarding payment step for a platform.
Records whether the payment step was completed, skipped, or is in progress.
 */
export const confirmOnboardingPaymentStep = (
    platformId: string,
    confirmOnboardingPaymentStepForPlatformRequest: ConfirmOnboardingPaymentStepForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-onboarding-payment-step`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmOnboardingPaymentStepForPlatformRequest, signal
    },
      );
    }
  


export const getConfirmOnboardingPaymentStepMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingPaymentStep>>, TError,{platformId: string;data: ConfirmOnboardingPaymentStepForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingPaymentStep>>, TError,{platformId: string;data: ConfirmOnboardingPaymentStepForPlatformRequest}, TContext> => {

const mutationKey = ['confirmOnboardingPaymentStep'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOnboardingPaymentStep>>, {platformId: string;data: ConfirmOnboardingPaymentStepForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  confirmOnboardingPaymentStep(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOnboardingPaymentStepMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOnboardingPaymentStep>>>
    export type ConfirmOnboardingPaymentStepMutationBody = ConfirmOnboardingPaymentStepForPlatformRequest
    export type ConfirmOnboardingPaymentStepMutationError = ErrorType<unknown>

    /**
 * @summary Confirms the onboarding payment step for a platform.
Records whether the payment step was completed, skipped, or is in progress.
 */
export const useConfirmOnboardingPaymentStep = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingPaymentStep>>, TError,{platformId: string;data: ConfirmOnboardingPaymentStepForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmOnboardingPaymentStep>>,
        TError,
        {platformId: string;data: ConfirmOnboardingPaymentStepForPlatformRequest},
        TContext
      > => {
      return useMutation(getConfirmOnboardingPaymentStepMutationOptions(options));
    }
    /**
 * @summary Confirms the onboarding catalog upload step for a platform.
Records whether the catalog upload was completed or skipped, along with the file count.
 */
export const confirmOnboardingCatalogUpload = (
    platformId: string,
    confirmOnboardingCatalogUploadForPlatformRequest: ConfirmOnboardingCatalogUploadForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-onboarding-catalog-upload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmOnboardingCatalogUploadForPlatformRequest, signal
    },
      );
    }
  


export const getConfirmOnboardingCatalogUploadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingCatalogUpload>>, TError,{platformId: string;data: ConfirmOnboardingCatalogUploadForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingCatalogUpload>>, TError,{platformId: string;data: ConfirmOnboardingCatalogUploadForPlatformRequest}, TContext> => {

const mutationKey = ['confirmOnboardingCatalogUpload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOnboardingCatalogUpload>>, {platformId: string;data: ConfirmOnboardingCatalogUploadForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  confirmOnboardingCatalogUpload(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOnboardingCatalogUploadMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOnboardingCatalogUpload>>>
    export type ConfirmOnboardingCatalogUploadMutationBody = ConfirmOnboardingCatalogUploadForPlatformRequest
    export type ConfirmOnboardingCatalogUploadMutationError = ErrorType<unknown>

    /**
 * @summary Confirms the onboarding catalog upload step for a platform.
Records whether the catalog upload was completed or skipped, along with the file count.
 */
export const useConfirmOnboardingCatalogUpload = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingCatalogUpload>>, TError,{platformId: string;data: ConfirmOnboardingCatalogUploadForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmOnboardingCatalogUpload>>,
        TError,
        {platformId: string;data: ConfirmOnboardingCatalogUploadForPlatformRequest},
        TContext
      > => {
      return useMutation(getConfirmOnboardingCatalogUploadMutationOptions(options));
    }
    /**
 * @summary Updates the platform domain for the PLG onboarding branding step.
Applies onboarding-specific authorization and completed-assessment rules
while preserving the legacy domain update side effects.
 */
export const updatePlgOnboardingBrandingDomain = (
    platformId: string,
    updatePlatformDomainRequest: UpdatePlatformDomainRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<PlatformModel>(
      {url: `/api/v1/platforms/${platformId}/plg-onboarding-branding-domain`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformDomainRequest, signal
    },
      );
    }
  


export const getUpdatePlgOnboardingBrandingDomainMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlgOnboardingBrandingDomain>>, TError,{platformId: string;data: UpdatePlatformDomainRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlgOnboardingBrandingDomain>>, TError,{platformId: string;data: UpdatePlatformDomainRequest}, TContext> => {

const mutationKey = ['updatePlgOnboardingBrandingDomain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlgOnboardingBrandingDomain>>, {platformId: string;data: UpdatePlatformDomainRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  updatePlgOnboardingBrandingDomain(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlgOnboardingBrandingDomainMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlgOnboardingBrandingDomain>>>
    export type UpdatePlgOnboardingBrandingDomainMutationBody = UpdatePlatformDomainRequest
    export type UpdatePlgOnboardingBrandingDomainMutationError = ErrorType<void>

    /**
 * @summary Updates the platform domain for the PLG onboarding branding step.
Applies onboarding-specific authorization and completed-assessment rules
while preserving the legacy domain update side effects.
 */
export const useUpdatePlgOnboardingBrandingDomain = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlgOnboardingBrandingDomain>>, TError,{platformId: string;data: UpdatePlatformDomainRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePlgOnboardingBrandingDomain>>,
        TError,
        {platformId: string;data: UpdatePlatformDomainRequest},
        TContext
      > => {
      return useMutation(getUpdatePlgOnboardingBrandingDomainMutationOptions(options));
    }
    /**
 * @summary Confirms the onboarding branding step for a platform.
Records the branding details (app name, brand color, logo, domain) confirmed during onboarding.
 */
export const confirmOnboardingBranding = (
    platformId: string,
    confirmOnboardingBrandingForPlatformRequest: ConfirmOnboardingBrandingForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-onboarding-branding`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmOnboardingBrandingForPlatformRequest, signal
    },
      );
    }
  


export const getConfirmOnboardingBrandingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingBranding>>, TError,{platformId: string;data: ConfirmOnboardingBrandingForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingBranding>>, TError,{platformId: string;data: ConfirmOnboardingBrandingForPlatformRequest}, TContext> => {

const mutationKey = ['confirmOnboardingBranding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOnboardingBranding>>, {platformId: string;data: ConfirmOnboardingBrandingForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  confirmOnboardingBranding(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOnboardingBrandingMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOnboardingBranding>>>
    export type ConfirmOnboardingBrandingMutationBody = ConfirmOnboardingBrandingForPlatformRequest
    export type ConfirmOnboardingBrandingMutationError = ErrorType<unknown>

    /**
 * @summary Confirms the onboarding branding step for a platform.
Records the branding details (app name, brand color, logo, domain) confirmed during onboarding.
 */
export const useConfirmOnboardingBranding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingBranding>>, TError,{platformId: string;data: ConfirmOnboardingBrandingForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmOnboardingBranding>>,
        TError,
        {platformId: string;data: ConfirmOnboardingBrandingForPlatformRequest},
        TContext
      > => {
      return useMutation(getConfirmOnboardingBrandingMutationOptions(options));
    }
    /**
 * @summary Regenerates the platform's brand icons (mobile app icon and favicon) from a logo and applies them,
retaining the icons they replace so the practice can undo.
 */
export const regenerateBrandIcons = (
    platformId: string,
    regenerateBrandIconsForPlatformRequest: RegenerateBrandIconsForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/brand-icons/regenerate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: regenerateBrandIconsForPlatformRequest, signal
    },
      );
    }
  


export const getRegenerateBrandIconsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateBrandIcons>>, TError,{platformId: string;data: RegenerateBrandIconsForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regenerateBrandIcons>>, TError,{platformId: string;data: RegenerateBrandIconsForPlatformRequest}, TContext> => {

const mutationKey = ['regenerateBrandIcons'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateBrandIcons>>, {platformId: string;data: RegenerateBrandIconsForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  regenerateBrandIcons(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RegenerateBrandIconsMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateBrandIcons>>>
    export type RegenerateBrandIconsMutationBody = RegenerateBrandIconsForPlatformRequest
    export type RegenerateBrandIconsMutationError = ErrorType<unknown>

    /**
 * @summary Regenerates the platform's brand icons (mobile app icon and favicon) from a logo and applies them,
retaining the icons they replace so the practice can undo.
 */
export const useRegenerateBrandIcons = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateBrandIcons>>, TError,{platformId: string;data: RegenerateBrandIconsForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof regenerateBrandIcons>>,
        TError,
        {platformId: string;data: RegenerateBrandIconsForPlatformRequest},
        TContext
      > => {
      return useMutation(getRegenerateBrandIconsMutationOptions(options));
    }
    /**
 * @summary Gets the platform's brand-icon generation state — the latest run's outcome and whether an
undo is available.
 */
export const getBrandIconState = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayBrandIconState>(
      {url: `/api/v1/platforms/${platformId}/brand-icons/state`, method: 'GET', signal
    },
      );
    }
  



export const getGetBrandIconStateQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/brand-icons/state`
    ] as const;
    }

    
export const getGetBrandIconStateQueryOptions = <TData = Awaited<ReturnType<typeof getBrandIconState>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandIconStateQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrandIconState>>> = ({ signal }) => getBrandIconState(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBrandIconStateQueryResult = NonNullable<Awaited<ReturnType<typeof getBrandIconState>>>
export type GetBrandIconStateQueryError = ErrorType<unknown>


/**
 * @summary Gets the platform's brand-icon generation state — the latest run's outcome and whether an
undo is available.
 */

export function useGetBrandIconState<TData = Awaited<ReturnType<typeof getBrandIconState>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBrandIconState>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBrandIconStateQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Undoes a brand-icon replacement by restoring the icon that was live before the most recent
generation, so a practice that dislikes a generated icon need not re-upload their previous one.
 */
export const restorePreviousBrandIcons = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/brand-icons/restore-previous`, method: 'POST', signal
    },
      );
    }
  


export const getRestorePreviousBrandIconsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restorePreviousBrandIcons>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof restorePreviousBrandIcons>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['restorePreviousBrandIcons'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restorePreviousBrandIcons>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  restorePreviousBrandIcons(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RestorePreviousBrandIconsMutationResult = NonNullable<Awaited<ReturnType<typeof restorePreviousBrandIcons>>>
    
    export type RestorePreviousBrandIconsMutationError = ErrorType<void>

    /**
 * @summary Undoes a brand-icon replacement by restoring the icon that was live before the most recent
generation, so a practice that dislikes a generated icon need not re-upload their previous one.
 */
export const useRestorePreviousBrandIcons = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restorePreviousBrandIcons>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof restorePreviousBrandIcons>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getRestorePreviousBrandIconsMutationOptions(options));
    }
    /**
 * @summary Confirms the onboarding business verification step for a platform.
Records whether the business verification step was skipped during onboarding.
 */
export const confirmOnboardingBusinessVerification = (
    platformId: string,
    confirmOnboardingBusinessVerificationForPlatformRequest: ConfirmOnboardingBusinessVerificationForPlatformRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/confirm-onboarding-business-verification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmOnboardingBusinessVerificationForPlatformRequest, signal
    },
      );
    }
  


export const getConfirmOnboardingBusinessVerificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingBusinessVerification>>, TError,{platformId: string;data: ConfirmOnboardingBusinessVerificationForPlatformRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingBusinessVerification>>, TError,{platformId: string;data: ConfirmOnboardingBusinessVerificationForPlatformRequest}, TContext> => {

const mutationKey = ['confirmOnboardingBusinessVerification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmOnboardingBusinessVerification>>, {platformId: string;data: ConfirmOnboardingBusinessVerificationForPlatformRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  confirmOnboardingBusinessVerification(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmOnboardingBusinessVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof confirmOnboardingBusinessVerification>>>
    export type ConfirmOnboardingBusinessVerificationMutationBody = ConfirmOnboardingBusinessVerificationForPlatformRequest
    export type ConfirmOnboardingBusinessVerificationMutationError = ErrorType<unknown>

    /**
 * @summary Confirms the onboarding business verification step for a platform.
Records whether the business verification step was skipped during onboarding.
 */
export const useConfirmOnboardingBusinessVerification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmOnboardingBusinessVerification>>, TError,{platformId: string;data: ConfirmOnboardingBusinessVerificationForPlatformRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmOnboardingBusinessVerification>>,
        TError,
        {platformId: string;data: ConfirmOnboardingBusinessVerificationForPlatformRequest},
        TContext
      > => {
      return useMutation(getConfirmOnboardingBusinessVerificationMutationOptions(options));
    }
    /**
 * @summary Extracts branding information from a public website URL.
 */
export const extractBranding = (
    extractPlatformBrandingRequest: ExtractPlatformBrandingRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayExtractedPlatformBranding>(
      {url: `/api/v1/platforms/branding/extract`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: extractPlatformBrandingRequest, signal
    },
      );
    }
  


export const getExtractBrandingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractBranding>>, TError,{data: ExtractPlatformBrandingRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof extractBranding>>, TError,{data: ExtractPlatformBrandingRequest}, TContext> => {

const mutationKey = ['extractBranding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extractBranding>>, {data: ExtractPlatformBrandingRequest}> = (props) => {
          const {data} = props ?? {};

          return  extractBranding(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ExtractBrandingMutationResult = NonNullable<Awaited<ReturnType<typeof extractBranding>>>
    export type ExtractBrandingMutationBody = ExtractPlatformBrandingRequest
    export type ExtractBrandingMutationError = ErrorType<unknown>

    /**
 * @summary Extracts branding information from a public website URL.
 */
export const useExtractBranding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractBranding>>, TError,{data: ExtractPlatformBrandingRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof extractBranding>>,
        TError,
        {data: ExtractPlatformBrandingRequest},
        TContext
      > => {
      return useMutation(getExtractBrandingMutationOptions(options));
    }
    /**
 * @summary Submits a subscription cancellation request for the specified Platform.
Creates or updates a Salesforce Case of type "Cancellation Request".
 */
export const submitCancellationRequest = (
    platformId: string,
    submitCancellationRequest: SubmitCancellationRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/cancellation-request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitCancellationRequest, signal
    },
      );
    }
  


export const getSubmitCancellationRequestMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCancellationRequest>>, TError,{platformId: string;data: SubmitCancellationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitCancellationRequest>>, TError,{platformId: string;data: SubmitCancellationRequest}, TContext> => {

const mutationKey = ['submitCancellationRequest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitCancellationRequest>>, {platformId: string;data: SubmitCancellationRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  submitCancellationRequest(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitCancellationRequestMutationResult = NonNullable<Awaited<ReturnType<typeof submitCancellationRequest>>>
    export type SubmitCancellationRequestMutationBody = SubmitCancellationRequest
    export type SubmitCancellationRequestMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Submits a subscription cancellation request for the specified Platform.
Creates or updates a Salesforce Case of type "Cancellation Request".
 */
export const useSubmitCancellationRequest = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCancellationRequest>>, TError,{platformId: string;data: SubmitCancellationRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitCancellationRequest>>,
        TError,
        {platformId: string;data: SubmitCancellationRequest},
        TContext
      > => {
      return useMutation(getSubmitCancellationRequestMutationOptions(options));
    }
    /**
 * @summary Undoes a previously submitted subscription cancellation request by closing
the open Salesforce Case for the specified Platform.
 */
export const undoCancellationRequest = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/cancellation-request`, method: 'DELETE', signal
    },
      );
    }
  


export const getUndoCancellationRequestMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoCancellationRequest>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof undoCancellationRequest>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['undoCancellationRequest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof undoCancellationRequest>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  undoCancellationRequest(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UndoCancellationRequestMutationResult = NonNullable<Awaited<ReturnType<typeof undoCancellationRequest>>>
    
    export type UndoCancellationRequestMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Undoes a previously submitted subscription cancellation request by closing
the open Salesforce Case for the specified Platform.
 */
export const useUndoCancellationRequest = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undoCancellationRequest>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof undoCancellationRequest>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getUndoCancellationRequestMutationOptions(options));
    }
    /**
 * @summary Records that a practice has opted for a free month and Back-On-Track playbook
instead of cancelling their subscription.
 */
export const claimSecondChance = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/second-chance-claim`, method: 'POST', signal
    },
      );
    }
  


export const getClaimSecondChanceMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimSecondChance>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof claimSecondChance>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['claimSecondChance'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimSecondChance>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  claimSecondChance(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ClaimSecondChanceMutationResult = NonNullable<Awaited<ReturnType<typeof claimSecondChance>>>
    
    export type ClaimSecondChanceMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Records that a practice has opted for a free month and Back-On-Track playbook
instead of cancelling their subscription.
 */
export const useClaimSecondChance = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimSecondChance>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof claimSecondChance>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getClaimSecondChanceMutationOptions(options));
    }
    /**
 * @summary Retrieves all sales associates for a platform.
 */
export const getSalesAssociates = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplaySalesAssociateResponse[]>(
      {url: `/api/v1/platforms/${platformId}/sales-associates`, method: 'GET', signal
    },
      );
    }
  



export const getGetSalesAssociatesQueryKey = (platformId: string,) => {
    return [
    `/api/v1/platforms/${platformId}/sales-associates`
    ] as const;
    }

    
export const getGetSalesAssociatesQueryOptions = <TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesAssociatesQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesAssociates>>> = ({ signal }) => getSalesAssociates(platformId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSalesAssociatesQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesAssociates>>>
export type GetSalesAssociatesQueryError = ErrorType<unknown>


/**
 * @summary Retrieves all sales associates for a platform.
 */

export function useGetSalesAssociates<TData = Awaited<ReturnType<typeof getSalesAssociates>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesAssociates>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSalesAssociatesQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Creates a new sales associate for a platform.
 */
export const createSalesAssociate = (
    platformId: string,
    createSalesAssociateRequest: CreateSalesAssociateRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplaySalesAssociateResponse>(
      {url: `/api/v1/platforms/${platformId}/sales-associates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSalesAssociateRequest, signal
    },
      );
    }
  


export const getCreateSalesAssociateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalesAssociate>>, TError,{platformId: string;data: CreateSalesAssociateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSalesAssociate>>, TError,{platformId: string;data: CreateSalesAssociateRequest}, TContext> => {

const mutationKey = ['createSalesAssociate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSalesAssociate>>, {platformId: string;data: CreateSalesAssociateRequest}> = (props) => {
          const {platformId,data} = props ?? {};

          return  createSalesAssociate(platformId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSalesAssociateMutationResult = NonNullable<Awaited<ReturnType<typeof createSalesAssociate>>>
    export type CreateSalesAssociateMutationBody = CreateSalesAssociateRequest
    export type CreateSalesAssociateMutationError = ErrorType<unknown>

    /**
 * @summary Creates a new sales associate for a platform.
 */
export const useCreateSalesAssociate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSalesAssociate>>, TError,{platformId: string;data: CreateSalesAssociateRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSalesAssociate>>,
        TError,
        {platformId: string;data: CreateSalesAssociateRequest},
        TContext
      > => {
      return useMutation(getCreateSalesAssociateMutationOptions(options));
    }
    /**
 * @summary Updates an existing sales associate.
 */
export const updateSalesAssociate = (
    platformId: string,
    salesAssociateId: string,
    updateSalesAssociateRequest: UpdateSalesAssociateRequest,
 signal?: AbortSignal
) => {
      
      
      return customAxios<DisplaySalesAssociateResponse>(
      {url: `/api/v1/platforms/${platformId}/sales-associates/${salesAssociateId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSalesAssociateRequest, signal
    },
      );
    }
  


export const getUpdateSalesAssociateMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalesAssociate>>, TError,{platformId: string;salesAssociateId: string;data: UpdateSalesAssociateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSalesAssociate>>, TError,{platformId: string;salesAssociateId: string;data: UpdateSalesAssociateRequest}, TContext> => {

const mutationKey = ['updateSalesAssociate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSalesAssociate>>, {platformId: string;salesAssociateId: string;data: UpdateSalesAssociateRequest}> = (props) => {
          const {platformId,salesAssociateId,data} = props ?? {};

          return  updateSalesAssociate(platformId,salesAssociateId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSalesAssociateMutationResult = NonNullable<Awaited<ReturnType<typeof updateSalesAssociate>>>
    export type UpdateSalesAssociateMutationBody = UpdateSalesAssociateRequest
    export type UpdateSalesAssociateMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Updates an existing sales associate.
 */
export const useUpdateSalesAssociate = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalesAssociate>>, TError,{platformId: string;salesAssociateId: string;data: UpdateSalesAssociateRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSalesAssociate>>,
        TError,
        {platformId: string;salesAssociateId: string;data: UpdateSalesAssociateRequest},
        TContext
      > => {
      return useMutation(getUpdateSalesAssociateMutationOptions(options));
    }
    